import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ListasService } from '../../../../services/listas.service';
import { FormField } from '../../../../dto/util/form-field';
import { ListaValorConstants } from '../../../../constants/lista-valor.constants';
import { TramiteIcaService } from '../../../../services/tramite-ica.service';
import { PaisDto } from '../../../../dto/expediente/pais.dto';
import { DepartmentoDto } from '../../../../dto/expediente/departmento.dto';
import { MunicipioDto } from '../../../../dto/expediente/municipio.dto';
import { TipoTramiteConstants } from '../../../../constants/tipo-tramite.constants';
import { PersonaDto } from '../../../../dto/tramites/persona.dto';
import { TramiteIcaVariedadVegetalDto } from '../../../../dto/tramites/tramite-ica-variedad-vegetal.dto';
import { InfoPantallaDTO } from '../../../../dto/util/infoPantallaDTO';
import { UtilService } from '../../../../services/util.service';
import {
  ListaValorRequestDto,
  ListaValorResponseDto,
} from '../../../../dto/tramites/lista_valor.dto';
import { Constants } from '../../../../constants/constants';
import { AlertaModalService } from '../../../../services/util/alerta-modal.service';
import { Router } from '@angular/router';
import { PersonaLoginDTO } from '../../../../dto/util/persona.dto';
import { TipoDocumentoDto } from '../../../../dto/expediente/tipo-documento-dto.dto';
import { TramiteService } from '../../../../services/tramite.service';
import { TramiteDTO } from '../../models/tramiteDTO';
import { AnexoPrecargaResponseDto } from '../../../../dto/anexo/anexo-tramite.dto';
import { Location } from '@angular/common';
import { firstValueFrom, combineLatest } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TextTransformService } from '../../../util/text-transform/text-transform.service';
import { DatosAdicionalesService } from '../../../util/modal-datos/services/datos-adicionales.service';
import { DemandadoAuxDto } from "../../../../dto/tramites/demandado-aux.dto";
import { ArchivoItemDto } from '../../../util/archivos-tramite/dto/ArchivoItemDto';
import { ConfigurarCuentasService } from '../../../configuracion-cuenta/services/configurar-cuentas.service';
import { LanguageService } from '../../../../services/util/language.service';
import { FormComponent } from '../../../util/form/form.component';

@Component({
  selector: 'app-obtentor-variedad-vegetal',
  templateUrl: './obtentor-variedad-vegetal.component.html',
  styleUrl: './obtentor-variedad-vegetal.component.scss',
})
export class ObtentorVariedadVegetalComponent implements OnInit, OnDestroy {
  idiomaActual: string = 'es';
  infoPantalla!: InfoPantallaDTO;
  listaTipoEspecieIca: ListaValorResponseDto[] = [];
  listaTipoSociedad: ListaValorResponseDto[] = [];
  entidadId: number = Constants.ID_ENTIDAD_ICA;
  dataUsuario: PersonaLoginDTO | undefined;
  tiposDocumento: TipoDocumentoDto[] = [];
  archivosValidos: boolean = false;
  mostrarComponenteCarga: boolean = true;
  enviarEntidad: boolean = false;

  // ID persona
  idApoderado!: number;
  idDemandado!: number;
  idDemandante!: number;
  idRepresentante!: number;
  archivosPreCargados?: AnexoPrecargaResponseDto[];
  // Multilenguaje
  icaText: any = {};
  comunText: any = {};
  alertaText: any = {};
  // seteo inputs otro Departamento y municipio
  auxIdCountry: number[] = [];
  auxIdCountryRl: number[] = [];

  confirmacionEnvio: boolean = false;
  demandadoAux: DemandadoAuxDto = {};
  enviarCorreoDemandado: boolean = false;
  pesoTotalArchivosMB: string = '0.00';
  seleccionAceptoRechazoEnvio = false;

  proceso: string = '';
  entidad: string = '';
  tituloConDatos: string = '';
  // String
  nombreTramite = '';

  @ViewChildren(FormComponent) personaComponentes!: QueryList<FormComponent>;

  constructor(
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly listasService: ListasService,
    private readonly tramiteIcaService: TramiteIcaService,
    private readonly utilService: UtilService,
    private readonly alertaModalService: AlertaModalService,
    private readonly tramiteService: TramiteService,
    private readonly location: Location,
    private readonly translate: TranslateService,
    private languageService: LanguageService,
    private readonly textTransformService: TextTransformService,
    private readonly datosProvisionalesService: DatosAdicionalesService,
    private readonly _cuentaService: ConfigurarCuentasService
  ) {
    this.formGroupButton = this.fb.group({});
    combineLatest([
      this.translate.stream('tramites'),
      this.translate.stream('comun-label'),
    ]).subscribe(([tramitesText, comunLabelText]) => {
      // Procesar el texto de 'tramites'
      for (const key of Object.keys(tramitesText)) {
        this.icaText[key] = tramitesText[key];
      }

      // Procesar el texto de 'comun-label'
      for (const key of Object.keys(comunLabelText)) {
        this.comunText[key] = comunLabelText[key];
      }

      // Llamar a buildForms una sola vez
      this.buildForms();
    });
  }

  ngOnInit(): void {
    this.idiomaActual = this.languageService.getCurrentLanguage();

    this.languageService.currentLanguage$.subscribe(lang => {
      this.idiomaActual = lang;
    });
    this.tramiteService.obtenerNombreEntidadPorId(7).subscribe({
      next: (data) => {
        this.entidad = data.entidad;
        this.proceso = data.nombreCompletoTramite || '';
      },
      error: (err) => console.error('Error al obtener entidad y proceso:', err),
    });
    this.translate.stream('alertas').forEach(text => {
      for (const key of Object.keys(text)) {
        this.alertaText[key] = text[key];
      }
    });
    // Evento de recargar o cerrar pestaña
    // window.addEventListener('beforeunload', this.unloadNotification);
    // Consultar si existe un trámite pendiente
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    this.nombreTramite = JSON.parse(
      sessionStorage.getItem(Constants.TRAMITE_SELECCIONADO)!
    );
    // Se consume el servicio para listar los tipos de documentos
    this.listasService
      .getDocumentTypeList()
      .subscribe((resp: TipoDocumentoDto[]) => {
        this.tiposDocumento = resp;
      });
    // Se valida si existe un trámite pendiente por completar
    this.tramiteService
      .consultarTramitePendiente(
        infoInicioSesion.idUsuario,
        Constants.ICA_OBTVEG
      )
      .subscribe(resp => {
        if ((resp as { Id: number }).Id !== null) {
          // Se consume el servicio que obtiene el detalle del trámite
          this.alertaModalService.confirmacion(
            this.alertaText['continuar-solicitud-almacenada'],
            '',
            () => {
              this.mostrarComponenteCarga = false;
              this.dataUsuario = undefined;
              this.consultarTramitePorID(resp.Id);
            },
            () => {
              this.dataUsuario = JSON.parse(
                sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
              );
              setTimeout(() => {
                this.getDataUsuario();
              }, 1000);
            },
            true
          );
        } else {
          this.dataUsuario = JSON.parse(
            sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
          );
          setTimeout(() => {
            this.getDataUsuario();
          }, 1000);
        }
      });
    this.getCountries();
    this.listasService
      .listaValor(ListaValorConstants.TipoSociedadIca)
      .subscribe(response => {
        const data = response as ListaValorResponseDto[];
        this.listaTipoSociedad = data;

        this.formPersonaJuridicaDemandante =
          this.formPersonaJuridicaDemandante.map(field => {
            if (field.name === 'tipoSociedad') {
              field.options = data.map((item: ListaValorResponseDto) => ({
                Id: item.Id!,
                Nombre: item.Valor!,
              }));
            }
            return field;
          });
        this.formPersonaJuridicaDemandada =
          this.formPersonaJuridicaDemandada.map(field => {
            if (field.name === 'tipoSociedad') {
              field.options = data.map((item: ListaValorResponseDto) => ({
                Id: item.Id!,
                Nombre: item.Valor!,
              }));
            }
            return field;
          });
      });

    this.listasService
      .listaValor(ListaValorConstants.TipoEspecieIca)
      .subscribe(data => {
        const response = data as ListaValorResponseDto[];
        this.listaTipoEspecieIca = response;

        this.formDetalleSolicitud = this.formDetalleSolicitud.map(field => {
          if (field.name === 'tipoDeEspecie') {
            field.options = response.map((item: ListaValorResponseDto) => ({
              Id: item.Id!,
              Nombre: item.Valor!,
            }));
          }
          return field;
        });
      });

    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla:
        'Inicio de Proceso de obtentor variedad vegetal en la entidad Instituto Colombiano ' +
        'Agropecuario',
      descripcionPantalla:
        'En esta pantalla usted podrá iniciar un Proceso de obtentor variedad vegetal en el ' +
        'Instituto Colombiano Agropecuario',
      pasos: [],
      // Evento en el botón volver
      change: async op =>
        await this.guardarAntesDeSalir(
          this.alertaModalService,
          this.location,
          op
        ),
    };
    this.utilService.changeInfoPantalla(this.infoPantalla);
    // setTimeout(() => {
    //   this.getDataDemandante();
    // }, 1000);
  }

  // Función para mostrar alerta antes de salir de la pantalla
  async guardarAntesDeSalir(
    alertas: AlertaModalService,
    loc: Location,
    op?: () => void
  ) {
    await alertas.confirmacion(
      this.alertaText['recordatorio-campos-obligatorios'],
      this.alertaText['almacenar-progeso-solicitud'],
      async () => {
        try {
          const response = await this.onSubmitGuardar();
          if (response.success) {
            // Proceso exitoso, continuar normalmente
            if (op) {
              op();
            } else {
              loc.back();
            }
          } else {
            await alertas.confirmacion(
              this.alertaText['salir-o-continuar-diligenciando'],
              this.alertaText['datos-no-guardados'],
              () => {
                if (op) {
                  op();
                } else {
                  loc.back();
                }
              },
              () => {
                // El usuario decide continuar diligenciando
              }
            );
          }
        } catch (error) {
          // Manejo de errores de llamada al servicio
          await alertas.confirmacion(
            this.alertaText['salir-o-continuar-diligenciando'],
            this.alertaText['datos-no-guardados'],
            () => {
              if (op) {
                op();
              } else {
                loc.back();
              }
            },
            () => {
              // El usuario decide continuar diligenciando
            }
          );
        }
      },
      () => {
        if (op) {
          op();
        } else {
          loc.back();
        }
      }
    );
  }

  ngOnDestroy(): void {
    // Evento de recargar o cerrar pestaña
    // window.addEventListener('beforeunload', this.unloadNotification);
  }

  // Se consume el servicio de consultar el detalle del trámite según el ID
  consultarTramitePorID(id: number) {
    this.idTramiteObtentorVariedadVegetal = id;
    this.tramiteService
      .cargarTramitePendiente(id)
      .subscribe((resp: TramiteDTO) => {
        if (resp) {
          if (resp.anexos) {
            this.archivosPreCargados = resp.anexos;
            this.mostrarComponenteCarga = true;
          }
          if (resp.apoderado) {
            this.idApoderado = resp.apoderado.id;
            this.formApoderadoTramite = this.formApoderadoTramite.map(
              (field: FormField) => {
                switch (field.name) {
                  case 'primerNombre':
                    field.value = resp.apoderado.primerNombre
                      ? resp.apoderado.primerNombre
                      : undefined;
                    break;
                  case 'segundoNombre':
                    field.value = resp.apoderado.segundoNombre
                      ? resp.apoderado.segundoNombre
                      : undefined;
                    break;
                  case 'primerApellido':
                    field.value = resp.apoderado.primerApellido
                      ? resp.apoderado.primerApellido
                      : undefined;
                    break;
                  case 'segundoApellido':
                    field.value = resp.apoderado.segundoApellido
                      ? resp.apoderado.segundoApellido
                      : undefined;
                    break;
                  case 'typeOfDocument':
                    field.value = resp.apoderado.idTipoIdentificacion
                      ? resp.apoderado.idTipoIdentificacion
                      : undefined;
                    break;
                  case 'numeroDocumento':
                    field.value = resp.apoderado.identificacion
                      ? resp.apoderado.identificacion
                      : undefined;
                    break;
                  case 'tarjetaProfesional':
                    field.value = resp.apoderado.tarjetaProfesional
                      ? resp.apoderado.tarjetaProfesional
                      : undefined;
                    break;
                  case 'telefono':
                    field.value = resp.apoderado.telefonoPrincipal
                      ? resp.apoderado.telefonoPrincipal
                      : undefined;
                    break;
                  case 'country':
                    field.value = resp.apoderado.municipio.idPais
                      ? resp.apoderado.municipio.idPais
                      : undefined;
                    break;
                  case 'departament':
                    field.value = resp.apoderado.municipio.idDepartamento
                      ? resp.apoderado.municipio.idDepartamento
                      : undefined;
                    break;
                  case 'municipality':
                    field.value = resp.apoderado.municipio.id
                      ? resp.apoderado.municipio.id
                      : undefined;
                    break;
                  case 'otroDepartamento':
                    field.value = resp.apoderado.otroDepartamento
                      ? resp.apoderado.otroDepartamento
                      : undefined;
                    break;
                  case 'otroMunicipio':
                    field.value = resp.apoderado.otroMunicipio
                      ? resp.apoderado.otroMunicipio
                      : undefined;
                    break;
                  case 'email':
                    field.value = resp.apoderado.correoElectronico
                      ? resp.apoderado.correoElectronico
                      : undefined;
                    break;
                  case 'direccionNotificacion':
                    field.value =
                      resp.apoderado.direccionPersona.length > 0
                        ? resp.apoderado.direccionPersona[0]
                          .direccionNotificacion
                        : undefined;
                    break;
                }
                return field;
              }
            );
          }

          if (resp.demandante.length > 0) {
            this.idDemandante = resp.demandante[0].id;
            this.formTipoPersonaDemandante = this.formTipoPersonaDemandante.map(
              (field: FormField) => {
                switch (field.name) {
                  case 'tipoPersonaSolicitante':
                    field.value = resp.demandante[0].idTipoPersona
                      ? resp.demandante[0].idTipoPersona
                      : undefined;
                    this.tipoPersonaDemandante =
                      resp.demandante[0].idTipoPersona;
                    break;
                }
                return field;
              }
            );
            if (resp.demandante[0].idTipoPersona === 1) {
              setTimeout(() => {
                this.formPersonaNaturalDemandante =
                  this.formPersonaNaturalDemandante.map((field: FormField) => {
                    const fecha = this.setDateValue(
                      resp.demandante[0].fechaNacimiento
                    );
                    switch (field.name) {
                      case 'primerNombre':
                        field.value = resp.demandante[0].primerNombre
                          ? resp.demandante[0].primerNombre
                          : undefined;
                        break;
                      case 'segundoNombre':
                        field.value = resp.demandante[0].segundoNombre
                          ? resp.demandante[0].segundoNombre
                          : undefined;
                        break;
                      case 'primerApellido':
                        field.value = resp.demandante[0].primerApellido
                          ? resp.demandante[0].primerApellido
                          : undefined;
                        break;
                      case 'segundoApellido':
                        field.value = resp.demandante[0].segundoApellido
                          ? resp.demandante[0].segundoApellido
                          : undefined;
                        break;
                      case 'typeOfDocument':
                        field.value = resp.demandante[0].idTipoIdentificacion
                          ? resp.demandante[0].idTipoIdentificacion
                          : undefined;
                        break;
                      case 'numeroDocumento':
                        field.value = resp.demandante[0].identificacion
                          ? resp.demandante[0].identificacion
                          : undefined;
                        break;
                      case 'fechaNacimiento':
                        field.value =
                          resp.demandante[0].fechaNacimiento !== null
                            ? fecha
                            : undefined;
                        break;
                      case 'email':
                        field.value = resp.demandante[0].correoElectronico
                          ? resp.demandante[0].correoElectronico
                          : undefined;
                        break;
                      case 'country':
                        field.value = resp.demandante[0].municipio.idPais
                          ? resp.demandante[0].municipio.idPais
                          : undefined;
                        break;
                      case 'departament':
                        field.value = resp.demandante[0].municipio
                          .idDepartamento
                          ? resp.demandante[0].municipio.idDepartamento
                          : undefined;
                        break;
                      case 'municipality':
                        field.value = resp.demandante[0].municipio.id
                          ? resp.demandante[0].municipio.id
                          : undefined;
                        break;
                      case 'otroDepartamento':
                        field.value = resp.demandante[0].otroDepartamento
                          ? resp.demandante[0].otroDepartamento
                          : undefined;
                        break;
                      case 'otroMunicipio':
                        field.value = resp.demandante[0].otroMunicipio
                          ? resp.demandante[0].otroMunicipio
                          : undefined;
                        break;
                      case 'direccionNotificacion':
                        field.value = resp.demandante[0].direccionPersona[0]
                          .direccionNotificacion
                          ? resp.demandante[0].direccionPersona[0]
                            .direccionNotificacion
                          : undefined;
                        break;
                    }
                    return field;
                  });
              }, 800);
            } else if (resp.demandante[0].idTipoPersona === 2) {
              setTimeout(() => {
                this.formPersonaJuridicaDemandante =
                  this.formPersonaJuridicaDemandante.map((field: FormField) => {
                    switch (field.name) {
                      case 'razonSocial':
                        field.value = resp.demandante[0].razonSocial
                          ? resp.demandante[0].razonSocial
                          : undefined;
                        break;
                      case 'idTipoIdentificacion':
                        field.value = Constants.NIT_ID;
                        break;
                      case 'tipoSociedad':
                        field.value = resp.demandante[0].tipoSociedad
                          ? resp.demandante[0].tipoSociedad.id
                          : undefined;
                        break;
                      case 'numeroDocumentoNit':
                        field.value = resp.demandante[0].identificacion
                          ? resp.demandante[0].identificacion
                          : undefined;
                        break;
                      case 'email':
                        field.value = resp.demandante[0].correoElectronico
                          ? resp.demandante[0].correoElectronico
                          : undefined;
                        break;
                      case 'country':
                        field.value = resp.demandante[0].municipio.idPais
                          ? resp.demandante[0].municipio.idPais
                          : undefined;
                        break;
                      case 'departament':
                        field.value = resp.demandante[0].municipio
                          .idDepartamento
                          ? resp.demandante[0].municipio.idDepartamento
                          : undefined;
                        break;
                      case 'municipality':
                        field.value = resp.demandante[0].municipio.id
                          ? resp.demandante[0].municipio.id
                          : undefined;
                        break;
                      case 'otroDepartamento':
                        field.value = resp.demandante[0].otroDepartamento
                          ? resp.demandante[0].otroDepartamento
                          : undefined;
                        break;
                      case 'otroMunicipio':
                        field.value = resp.demandante[0].otroMunicipio
                          ? resp.demandante[0].otroMunicipio
                          : undefined;
                        break;
                      case 'address':
                        field.value = resp.demandante[0].direccionPersona[0]
                          .direccionNotificacion
                          ? resp.demandante[0].direccionPersona[0]
                            .direccionNotificacion
                          : undefined;
                        break;
                    }
                    return field;
                  });
              }, 800);
              if (resp.demandante[0].datosRepresentanteLegal) {
                this.idRepresentante =
                  resp.demandante[0].datosRepresentanteLegal.id;
                setTimeout(() => {
                  this.formPersonaJuridicaDemandante =
                    this.formPersonaJuridicaDemandante.map(
                      (field: FormField) => {
                        switch (field.name) {
                          case 'primeroNombreRepLegal':
                            field.value = resp.demandante[0]
                              .datosRepresentanteLegal.primerNombre
                              ? resp.demandante[0].datosRepresentanteLegal
                                .primerNombre
                              : undefined;
                            break;
                          case 'segundoNombreRepLegal':
                            field.value = resp.demandante[0]
                              .datosRepresentanteLegal.segundoNombre
                              ? resp.demandante[0].datosRepresentanteLegal
                                .segundoNombre
                              : undefined;
                            break;
                          case 'primerApellidoRepLegal':
                            field.value = resp.demandante[0]
                              .datosRepresentanteLegal.primerApellido
                              ? resp.demandante[0].datosRepresentanteLegal
                                .primerApellido
                              : undefined;
                            break;
                          case 'segundoApellidoRepLegal':
                            field.value = resp.demandante[0]
                              .datosRepresentanteLegal.segundoApellido
                              ? resp.demandante[0].datosRepresentanteLegal
                                .segundoApellido
                              : undefined;
                            break;
                          case 'typeOfDocument':
                            field.value = resp.demandante[0]
                              .datosRepresentanteLegal.idTipoIdentificacion
                              ? resp.demandante[0].datosRepresentanteLegal
                                .idTipoIdentificacion
                              : undefined;
                            break;
                          case 'numeroDocumentoRepLegal':
                            field.value = resp.demandante[0]
                              .datosRepresentanteLegal.identificacion
                              ? resp.demandante[0].datosRepresentanteLegal
                                .identificacion
                              : undefined;
                            break;
                          case 'emailRepLegal':
                            field.value = resp.demandante[0]
                              .datosRepresentanteLegal.correoElectronico
                              ? resp.demandante[0].datosRepresentanteLegal
                                .correoElectronico
                              : undefined;
                            break;
                          case 'countryRepLegal':
                            field.value = resp.demandante[0]
                              .datosRepresentanteLegal.municipio.idPais
                              ? resp.demandante[0].datosRepresentanteLegal
                                .municipio.idPais
                              : undefined;
                            break;
                          case 'departamentRepLegal':
                            field.value = resp.demandante[0]
                              .datosRepresentanteLegal.municipio.idDepartamento
                              ? resp.demandante[0].datosRepresentanteLegal
                                .municipio.idDepartamento
                              : undefined;
                            break;
                          case 'municipalityRepLegal':
                            field.value = resp.demandante[0]
                              .datosRepresentanteLegal.municipio.id
                              ? resp.demandante[0].datosRepresentanteLegal
                                .municipio.id
                              : undefined;
                            break;
                          case 'otroDepartamentoRepLegal':
                            field.value = resp.demandante[0]
                              .datosRepresentanteLegal.otroDepartamento
                              ? resp.demandante[0].datosRepresentanteLegal
                                .otroDepartamento
                              : undefined;
                            break;
                          case 'otroMunicipioRepLegal':
                            field.value = resp.demandante[0]
                              .datosRepresentanteLegal.otroMunicipio
                              ? resp.demandante[0].datosRepresentanteLegal
                                .otroMunicipio
                              : undefined;
                            break;
                          case 'direccionNotificacion':
                            field.value = resp.demandante[0]
                              .datosRepresentanteLegal.direccionPersona[0]
                              .direccionNotificacion
                              ? resp.demandante[0].datosRepresentanteLegal
                                .direccionPersona[0].direccionNotificacion
                              : undefined;
                            break;
                        }
                        return field;
                      }
                    );
                }, 800);
              }
            }
          }

          if (resp.demandado.length > 0) {
            this.idDemandado = resp.demandado[0].id;
            this.formTipoPersonaDemandanda = this.formTipoPersonaDemandanda.map(
              (field: FormField) => {
                switch (field.name) {
                  case 'tipoPersonaDemandada':
                    field.value = resp.demandado[0].idTipoPersona
                      ? resp.demandado[0].idTipoPersona
                      : undefined;
                    this.tipoPersonaDemandanda =
                      resp.demandado[0].idTipoPersona;
                    break;
                }
                return field;
              }
            );

            if (resp.demandado[0].idTipoPersona === 1) {
              setTimeout(() => {
                this.formPersonaNaturalDemandada =
                  this.formPersonaNaturalDemandada.map((field: FormField) => {
                    switch (field.name) {
                      case 'primerNombre':
                        field.value = resp.demandado[0].primerNombre
                          ? resp.demandado[0].primerNombre
                          : undefined;
                        break;
                      case 'segundoNombre':
                        field.value = resp.demandado[0].segundoNombre
                          ? resp.demandado[0].segundoNombre
                          : undefined;
                        break;
                      case 'primerApellido':
                        field.value = resp.demandado[0].primerApellido
                          ? resp.demandado[0].primerApellido
                          : undefined;
                        break;
                      case 'segundoApellido':
                        field.value = resp.demandado[0].segundoApellido
                          ? resp.demandado[0].segundoApellido
                          : undefined;
                        break;
                      case 'typeOfDocument':
                        field.value = resp.demandado[0].idTipoIdentificacion
                          ? resp.demandado[0].idTipoIdentificacion
                          : undefined;
                        break;
                      case 'numeroDocumento':
                        field.value = resp.demandado[0].identificacion
                          ? resp.demandado[0].identificacion
                          : undefined;
                        break;
                      case 'email':
                        field.value = resp.demandado[0].correoElectronico
                          ? resp.demandado[0].correoElectronico
                          : undefined;
                        break;
                      case 'country':
                        field.value = resp.demandado[0].municipio.idPais
                          ? resp.demandado[0].municipio.idPais
                          : undefined;
                        break;
                      case 'departament':
                        field.value = resp.demandado[0].municipio.idDepartamento
                          ? resp.demandado[0].municipio.idDepartamento
                          : undefined;
                        break;
                      case 'municipality':
                        field.value = resp.demandado[0].municipio.id
                          ? resp.demandado[0].municipio.id
                          : undefined;
                        break;
                      case 'otroDepartamento':
                        field.value = resp.demandado[0].otroDepartamento
                          ? resp.demandado[0].otroDepartamento
                          : undefined;
                        break;
                      case 'otroMunicipio':
                        field.value = resp.demandado[0].otroMunicipio
                          ? resp.demandado[0].otroMunicipio
                          : undefined;
                        break;
                      case 'direccionNotificacion':
                        field.value =
                          resp.demandado[0].direccionPersona.length > 0
                            ? resp.demandado[0].direccionPersona[0]
                              .direccionNotificacion
                            : undefined;
                        break;
                    }
                    return field;
                  });
              }, 800);
            } else if (resp.demandado[0].idTipoPersona === 2) {
              setTimeout(() => {
                this.formPersonaJuridicaDemandada =
                  this.formPersonaJuridicaDemandada.map((field: FormField) => {
                    switch (field.name) {
                      case 'razonSocial':
                        field.value = resp.demandado[0].razonSocial
                          ? resp.demandado[0].razonSocial
                          : undefined;
                        break;
                      case 'idTipoIdentificacion':
                        field.value = Constants.NIT_ID;
                        break;
                      case 'tipoSociedad':
                        field.value = resp.demandado[0].tipoSociedad
                          ? resp.demandado[0].tipoSociedad.id
                          : undefined;
                        break;
                      case 'numeroDocumentoNit':
                        field.value = resp.demandado[0].identificacion
                          ? resp.demandado[0].identificacion
                          : undefined;
                        break;
                      case 'email':
                        field.value = resp.demandado[0].correoElectronico
                          ? resp.demandado[0].correoElectronico
                          : undefined;
                        break;
                      case 'country':
                        field.value = resp.demandado[0].municipio.idPais
                          ? resp.demandado[0].municipio.idPais
                          : undefined;
                        break;
                      case 'departament':
                        field.value = resp.demandado[0].municipio.idDepartamento
                          ? resp.demandado[0].municipio.idDepartamento
                          : undefined;
                        break;
                      case 'municipality':
                        field.value = resp.demandado[0].municipio.id
                          ? resp.demandado[0].municipio.id
                          : undefined;
                        break;
                      case 'otroDepartamento':
                        field.value = resp.demandado[0].otroDepartamento
                          ? resp.demandado[0].otroDepartamento
                          : undefined;
                        break;
                      case 'otroMunicipio':
                        field.value = resp.demandado[0].otroMunicipio
                          ? resp.demandado[0].otroMunicipio
                          : undefined;
                        break;
                      case 'direccionNotificacion':
                        field.value =
                          resp.demandado[0].direccionPersona.length > 0
                            ? resp.demandado[0].direccionPersona[0]
                              .direccionNotificacion
                            : undefined;
                        break;
                    }
                    return field;
                  });
              }, 800);
            }
          }

          if (resp.tipoEspecie) {
            this.formDetalleSolicitud = this.formDetalleSolicitud.map(
              (field: FormField) => {
                switch (field.name) {
                  case 'tipoDeEspecie':
                    field.value = resp.tipoEspecie.id
                      ? resp.tipoEspecie.id
                      : undefined;
                    break;
                }
                return field;
              }
            );
          }

          if (resp.nombreEspecie) {
            this.formDetalleSolicitud = this.formDetalleSolicitud.map(
              (field: FormField) => {
                switch (field.name) {
                  case 'nombreEspecie':
                    field.value = resp.nombreEspecie
                      ? resp.nombreEspecie
                      : undefined;
                    break;
                }
                return field;
              }
            );
          }

          if (resp.variedadVegetal) {
            this.formDetalleSolicitud = this.formDetalleSolicitud.map(
              (field: FormField) => {
                switch (field.name) {
                  case 'denominacionVariedadVegetal':
                    field.value = resp.variedadVegetal
                      ? resp.variedadVegetal
                      : undefined;
                    break;
                }
                return field;
              }
            );
          }

          if (resp.municipio) {
            setTimeout(() => {
              this.formDetalleSolicitud = this.formDetalleSolicitud.map(
                (field: FormField) => {
                  switch (field.name) {
                    case 'country':
                      field.value = resp.municipio.idPais
                        ? resp.municipio.idPais
                        : undefined;
                      break;
                    case 'departament':
                      field.value = resp.municipio.idDepartamento
                        ? resp.municipio.idDepartamento
                        : undefined;
                      break;
                    case 'municipality':
                      field.value = resp.municipio.id
                        ? resp.municipio.id
                        : undefined;
                      break;
                    case 'otroDepartamento':
                      field.value = resp.otroDepartamento
                        ? resp.otroDepartamento
                        : undefined;
                      break;
                    case 'otroMunicipio':
                      field.value = resp.otroMunicipio
                        ? resp.otroMunicipio
                        : undefined;
                      break;
                  }
                  return field;
                }
              );
            }, 800);
          }
        }
      });
  }

  setDateValue(dateString: string): string | undefined {
    if (!dateString) return; // Manejo de caso nulo o vacío
    const date = new Date(dateString);
    const formattedDate = date.toISOString().split('T')[0]; // Formato yyyy-MM-dd
    return formattedDate;
  }

  idTipoDocumentoDemandadoPN: number = 0;
  idTipoDocumentoDemandadoPJ: number = 0;
  idTipoDocumentoApoderado: number = 0;
  idTipoDocumentoDemandantePN: number = 0;
  idTipoDocumentoDemandantePJ: number = 0;

  idTramite?: number = undefined;

  private firstTime: boolean = false;

  formGroupButton: FormGroup;
  enviarDocumentos: boolean = false;

  // Validación de formularios enviados

  formularioDemandanteEnviado: boolean = false;
  formularioDemandadoEnviado: boolean = false;
  formularioApoderadoEnviado: boolean = false;
  formularioDetalleTramiteEnviado: boolean = false;
  //
  tipoPersonaDemandante!: number;
  tipoPersonaDemandanda!: number;
  idTramiteObtentorVariedadVegetal!: number;
  tipoTramite: number =
    TipoTramiteConstants.ID_TRAMITE_OBTENTOR_VARIEDAD_VEGETAL;

  // Validadores de formularios
  tipoPersonaDemandanteValida = false;
  personaNaturalDemandanteValida = false;
  personaNaturalDemandadaValida = false;
  apoderadoTramiteValida = false;
  tipoPersonaDemandadaValida = false;
  personaJuridicaDemandanteValida = false;
  personaJuridicaDemandadaValida = false;
  solicitudTramiteValida = false;

  // Formularios
  formGroupTipoPersonaDemandada!: FormGroup;
  formGroupTipoPersonaDemandante!: FormGroup;
  formGroupPersonaNaturalDemandante!: FormGroup;
  formGroupPersonaJuridicaDemandante!: FormGroup;
  formGroupApoderadoTramite!: FormGroup;
  formGroupPersonaNaturalDemandada!: FormGroup;
  formGroupPersonaJuridicaDemandada!: FormGroup;
  formGroupInformacionTramite!: FormGroup;

  // Objetos para creación de formularios
  formTipoPersonaDemandante: FormField[] = [
  ];

  formTipoPersonaDemandanda: FormField[] = [
  ];

  formPersonaNaturalDemandante: FormField[] = [];

  formPersonaJuridicaDemandante: FormField[] = [];

  formApoderadoTramite: FormField[] = [];

  formPersonaNaturalDemandada: FormField[] = [];

  formPersonaJuridicaDemandada: FormField[] = [];

  formDetalleSolicitud: FormField[] = [];

  paises: PaisDto[] = [];

  buildForms() {
    this.formTipoPersonaDemandante = [
      {
        name: 'tipoPersonaSolicitante',
        label: this.comunText['tipo-demandante'],
        type: 'select',
        required: true,
        options: [
          { Id: 1, Nombre: this.comunText['persona-natural-select'] },
          { Id: 2, Nombre: this.comunText['persona-juridica-select'] },
        ],
        width: '12',
        visible: true,
        errorMessages: { required: this.comunText['tipo-persona-required'] },
      },
    ];

    this.formTipoPersonaDemandanda = [
      {
        name: 'tipoPersonaDemandada',
        label: this.comunText['tipo-demandado'],
        type: 'select',
        required: true,
        options: [
          { Id: 1, Nombre: this.comunText['persona-natural-select'] },
          { Id: 2, Nombre: this.comunText['persona-juridica-select'] },
        ],
        width: '12',
        visible: true,
        errorMessages: { required: this.comunText['tipo-persona-required'] },
      },
    ];

    this.formDetalleSolicitud = [
      {
        name: 'tipoDeEspecie',
        label: this.icaText['tramite-ica']['tipo-especie'],
        type: 'select',
        required: true,
        options: [],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.icaText['tramite-ica']['tipo-especie-required'],
        },
      },
      {
        name: 'nombreEspecie',
        label: this.icaText['tramite-ica']['nombre-especie'],
        type: 'text',
        required: true,
        placeholder: this.icaText['tramite-ica']['nombre-especie-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(3),
          Validators.maxLength(50),
          Validators.pattern(Constants.REGEX_STRING_VALIDATION),
        ],
        errorMessages: {
          required: this.icaText['tramite-ica']['nombre-especie-required'],
          minlength: this.icaText['tramite-ica']['nombre-especie-minlength'],
          maxlength: this.icaText['tramite-ica']['nombre-especie-maxlength'],
          pattern: this.icaText['tramite-ica']['nombre-especie-pattern'],
        },
      },
      {
        name: 'denominacionVariedadVegetal',
        label: this.icaText['tramite-ica']['denominacion-variedad-vegetal'],
        type: 'text',
        required: true,
        placeholder:
          this.icaText['tramite-ica'][
          'denominacion-variedad-vegetal-placeholder'
          ],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(3),
          Validators.maxLength(50),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES),
        ],
        errorMessages: {
          required:
            this.icaText['tramite-ica'][
            'denominacion-variedad-vegetal-required'
            ],
          minlength:
            this.icaText['tramite-ica'][
            'denominacion-variedad-vegetal-minlength'
            ],
          maxlength:
            this.icaText['tramite-ica'][
            'denominacion-variedad-vegetal-maxlength'
            ],
          pattern:
            this.icaText['tramite-ica'][
            'denominacion-variedad-vegetal-pattern'
            ],
        },
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['required'] },
        //value: 1,
      },
      {
        name: 'departament',
        label: this.icaText['tramite-ica']['departament'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['departament-required'] },
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'municipality',
        label: this.icaText['tramite-ica']['municipality'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['municipality-required'] },
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.icaText['crear-demanda']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.icaText['crear-demanda']['escriba-departamento'],
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.icaText['crear-demanda']['campo-requerido'],
          maxlength: this.icaText['crear-demanda']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.icaText['crear-demanda']['escriba-municipio'],
      },
    ];

    this.formPersonaNaturalDemandante = [
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        personTypeId: '1',
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'numeroDocumento',
        label: this.comunText['numero-documento'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        validation: [],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          maxlength: this.comunText['numero-documento-maxlength'],
          minlength: this.comunText['numero-documento-minlength'],
          pattern:
            'El valor mínimo permitido no se ha cumplido, No se permiten espacios al inicio ni al final',
        },
      },
      {
        name: 'fechaNacimiento',
        label: this.comunText['fecha-nacimiento'],
        type: 'date',
        required: false,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.comunText['fecha-nacimiento-required'],
          edadRequerida: `${this.comunText['fecha-nacimiento-edad-requerida']} ${Constants.ANIOS_REQUERIDOS} ${this.comunText['fecha-nacimiento-anio']}.`,
        },
      },
      {
        name: 'email',
        label: this.comunText['email'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['email-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['country-required'] },
        //value: 1,
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['departament-required'] },
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['municipality-required'] },
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.icaText['crear-demanda']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.icaText['crear-demanda']['escriba-departamento'],
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.icaText['crear-demanda']['campo-requerido'],
          maxlength: this.icaText['crear-demanda']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.icaText['crear-demanda']['escriba-municipio'],
      },
      {
        name: 'direccionNotificacion',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
          Validators.minLength(10),
          Validators.maxLength(40),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
        },
      },
    ];

    this.formPersonaJuridicaDemandante = [
      {
        name: 'idTipoIdentificacion',
        label: this.comunText['tipo-documento'],
        type: 'text',
        options: [],
        width: '6',
        visible: false,
        value: Constants.NIT_ID,
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        type: 'text',
        required: true,
        placeholder: this.comunText['razon-social-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ],
        errorMessages: {
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
          pattern: this.comunText['razon-social-pattern'],
        },
      },
      {
        name: 'tipoSociedad',
        label: this.comunText['tipo-sociedad'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-sociedad-required'] },
      },
      {
        name: 'numeroDocumentoNit',
        label: this.comunText['nit'],
        type: 'text',
        required: true,
        placeholder: this.icaText['tramite-ica']['nit-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.maxLength(9),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          maxlength: this.icaText['tramite-ica']['nit-maxlength'],
          pattern: this.icaText['tramite-ica']['nit-pattern'],
        },
      },
      {
        name: 'email',
        label: this.comunText['email'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['email-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['country-required'] },
        //value: 1,
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['departament-required'] },
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['municipality-required'] },
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.icaText['crear-demanda']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.icaText['crear-demanda']['escriba-departamento'],
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.icaText['crear-demanda']['campo-requerido'],
          maxlength: this.icaText['crear-demanda']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.icaText['crear-demanda']['escriba-municipio'],
      },
      {
        name: 'address',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
        },
      },
      {
        isSubtitle: true,
        subtitleText: this.comunText['subtitulo-representante'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'primeroNombreRepLegal',
        label: this.comunText['primer-nombre'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
          Validators.maxLength(25),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoNombreRepLegal',
        label: this.comunText['segundo-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
          Validators.maxLength(25),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'primerApellidoRepLegal',
        label: this.comunText['primer-apellido'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
          Validators.maxLength(25),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'segundoApellidoRepLegal',
        label: this.comunText['segundo-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
          Validators.maxLength(25),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        personTypeId: '1',
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'numeroDocumentoRepLegal',
        label: this.comunText['numero-documento'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        validation: [],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
        },
      },
      {
        name: 'emailRepLegal',
        label: this.comunText['email'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['email-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
      {
        name: 'countryRepLegal',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['country-required'] },
        //value: 1,
      },
      {
        name: 'departamentRepLegal',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['departament-required'] },
        dependsOn: 'countryRepLegal',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'municipalityRepLegal',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['municipality-required'] },
        dependsOn: 'countryRepLegal',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'otroDepartamentoRepLegal',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [Validators.maxLength(30)],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.icaText['crear-demanda']['campo-maxlength'],
        },
        dependsOn: 'countryRepLegal',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.icaText['crear-demanda']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioRepLegal',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [Validators.maxLength(30)],
        errorMessages: {
          required: this.icaText['crear-demanda']['campo-requerido'],
          maxlength: this.icaText['crear-demanda']['campo-maxlength'],
        },
        dependsOn: 'countryRepLegal',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.icaText['crear-demanda']['escriba-municipio'],
      },
      {
        name: 'direccionNotificacion',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
        },
      },
    ];

    this.formPersonaNaturalDemandada = [
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        personTypeId: '1',
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'numeroDocumento',
        label: this.comunText['numero-documento'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.comunText['numero-documento-required'],
        },
      },
      {
        name: 'email',
        label: this.comunText['email'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['email-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['country-required'] },
        //value: 1,
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['departament-required'] },
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['municipality-required'] },
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.icaText['crear-demanda']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.icaText['crear-demanda']['escriba-departamento'],
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.icaText['crear-demanda']['campo-requerido'],
          maxlength: this.icaText['crear-demanda']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.icaText['crear-demanda']['escriba-municipio'],
      },
      {
        name: 'direccionNotificacion',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder: this.comunText['direccion-notificacion-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
        },
      },
    ];

    this.formPersonaJuridicaDemandada = [
      {
        name: 'idTipoIdentificacion',
        label: this.comunText['tipo-documento'],
        type: 'text',
        options: [],
        width: '6',
        visible: false,
        value: Constants.NIT_ID,
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        type: 'text',
        required: true,
        placeholder: this.comunText['razon-social-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ],
        errorMessages: {
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
          pattern: this.comunText['razon-social-pattern'],
        },
      },
      {
        name: 'tipoSociedad',
        label: this.comunText['tipo-sociedad'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-sociedad-required'] },
      },
      {
        name: 'numeroDocumentoNit',
        label: this.comunText['nit'],
        type: 'text',
        required: true,
        placeholder: this.icaText['tramite-ica']['nit-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.maxLength(9),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          maxlength: this.icaText['tramite-ica']['nit-maxlength'],
          pattern: this.icaText['tramite-ica']['nit-pattern'],
        },
      },
      {
        name: 'email',
        label: this.comunText['email'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['email-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['country-required'] },
        //value: 1,
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['departament-required'] },
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['municipality-required'] },
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.icaText['crear-demanda']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.icaText['crear-demanda']['escriba-departamento'],
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.icaText['crear-demanda']['campo-requerido'],
          maxlength: this.icaText['crear-demanda']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.icaText['crear-demanda']['escriba-municipio'],
      },
      {
        name: 'direccionNotificacion',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
        },
      },
    ];

    this.formApoderadoTramite = [
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        personTypeId: '1',
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'numeroDocumento',
        label: this.comunText['numero-documento'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.comunText['numero-documento-required'],
        },
      },
      {
        name: 'tarjetaProfesional',
        label: this.comunText['tarjeta-profesional'],
        type: 'text',
        required: true,
        placeholder: this.comunText['tarjeta-profesional-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(3),
          Validators.maxLength(12),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['tarjeta-profesional-required'],
          minlength: this.comunText['tarjeta-profesional-minlength'],
          maxlength: this.comunText['tarjeta-profesional-maxlength'],
          pattern: this.comunText['tarjeta-profesional-pattern'],
        },
      },
      {
        name: 'email',
        label: this.comunText['email'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['email-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
      {
        name: 'telefono',
        label: this.comunText['telefono'],
        type: 'tel',
        required: false,
        placeholder: this.comunText['telefono-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
          pattern: this.comunText['telefono-pattern'],
        },
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['country-required'] },
        //value: 1,
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['departament-required'] },
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['municipality-required'] },
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.icaText['crear-demanda']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.icaText['crear-demanda']['escriba-departamento'],
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.icaText['crear-demanda']['campo-requerido'],
          maxlength: this.icaText['crear-demanda']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.icaText['crear-demanda']['escriba-municipio'],
      },
      {
        name: 'direccionNotificacion',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
        },
      },
    ];
  }

  // Valida el cambio de select para el tipo de persona demandante
  onChangeTipoPersonaDemandante(formGroup: FormGroup) {
    this.formGroupTipoPersonaDemandante = formGroup;
    this.tipoPersonaDemandante = formGroup?.get(
      'tipoPersonaSolicitante'
    )?.value;

    this.formGroupTipoPersonaDemandante?.valueChanges.subscribe(change => {
      this.tipoPersonaDemandante = change['tipoPersonaSolicitante'];
    });

    if (formGroup?.invalid) {
      this.tipoPersonaDemandanteValida = false;
    } else {
      this.tipoPersonaDemandanteValida = true;
    }
  }

  // Valida el cambio de select para el tipo de persona demandada
  onChangeTipoPersonaDemandada(formGroup: FormGroup) {
    this.formGroupTipoPersonaDemandada = formGroup;
    this.tipoPersonaDemandanda = formGroup?.get('tipoPersonaDemandada')?.value;

    this.formGroupTipoPersonaDemandada?.valueChanges.subscribe(change => {
      this.tipoPersonaDemandanda = change['tipoPersonaDemandada'];
    });

    if (formGroup?.invalid) {
      this.tipoPersonaDemandadaValida = false;
    } else {
      this.tipoPersonaDemandadaValida = true;
    }
  }

  // valida que al cambiar el formulario para demandante persona natural el mismo sea valido
  onChangePersonaNaturalDemandante(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    if (event.controlName == 'country') {
      this.validarPaisDeptoMuni(event.form, '');
    }
    this.formGroupPersonaNaturalDemandante = event.form;
    if (this.tipoPersonaDemandante === 1) {
      setTimeout(() => {
        if (
          this.formGroupPersonaNaturalDemandante.get('primerNombre')?.value ==
          undefined ||
          this.formGroupPersonaNaturalDemandante.get('primerApellido')?.value ==
          undefined
        ) {
          this.formGroupPersonaNaturalDemandante
            .get('primerNombre')
            ?.markAsDirty();
          this.formGroupPersonaNaturalDemandante
            .get('primerNombre')
            ?.markAllAsTouched();
          this.formGroupPersonaNaturalDemandante
            .get('primerApellido')
            ?.markAsDirty();
          this.formGroupPersonaNaturalDemandante
            .get('primerApellido')
            ?.markAllAsTouched();
        }
      }, 1100);
    }
    if (
      event.controlName == 'typeOfDocument' ||
      event.controlName == 'numeroDocumento'
    ) {
      const documentType =
        this.formGroupPersonaNaturalDemandante?.get('typeOfDocument')?.value;
      const documentNumber =
        this.formGroupPersonaNaturalDemandante?.get('numeroDocumento');
      const numeroDocumentoDemandandante =
        this.formPersonaNaturalDemandante.find(
          field => field.name == 'numeroDocumento'
        );

      if (documentType != null && documentNumber != null) {
        if (documentType == 4) {
          if (numeroDocumentoDemandandante != undefined) {
            documentNumber?.setValidators([
              Validators.required,
              Validators.maxLength(8),
              Validators.minLength(4),
              Validators.pattern(
                Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
              ),
            ]);
            numeroDocumentoDemandandante.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoDemandandante.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
            numeroDocumentoDemandandante.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength-ce'];
          }
        } else if (
          documentType == 1 ||
          documentType === 5 ||
          documentType === 2
        ) {
          if (numeroDocumentoDemandandante != undefined) {
            documentNumber?.setValidators([
              Validators.required,
              Validators.maxLength(12),
              Validators.minLength(4),
              Validators.pattern(Constants.REGEX_TELEFONO),
            ]);
            numeroDocumentoDemandandante.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoDemandandante.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoDemandandante.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        }
        this.idTipoDocumentoDemandantePN = documentType;
      }
      this.validarPersona('Demandante');
    }
    const email = this.formPersonaNaturalDemandante.find(
      field => field.name == 'email'
    );
    if (event.controlName == 'email') {
      if (email != undefined) {
        this.formGroupPersonaNaturalDemandante
          .get('email')
          ?.setValidators([
            Validators.required,
            Validators.maxLength(100),
            Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          ]);
        email.errorMessages!['pattern'] =
          'Formato de correo invalido, No se permiten espacios al inicio ni al final';
      }
    }
    if (event.form?.invalid) {
      this.personaNaturalDemandanteValida = false;
    } else {
      this.personaNaturalDemandanteValida = true;
    }
    this.validarIdentificacionesActores();
  }

  changePersonaNaturalDemandante(formGroup: FormGroup) {
    this.validarPaisDeptoMuni(formGroup, '');
  }

  // valida que al cambiar el formulario para demandante persona juridica el mismo sea valido
  onChangePersonaJuridicaDemandante(formGroup: FormGroup) {
    this.formGroupPersonaJuridicaDemandante = formGroup;
    const documentType =
      this.formGroupPersonaJuridicaDemandante?.get('typeOfDocument')?.value;
    const documentNumber = this.formGroupPersonaJuridicaDemandante?.get(
      'numeroDocumentoRepLegal'
    );
    const numeroDocumentoRepLegalDemandandante =
      this.formPersonaJuridicaDemandante.find(
        field => field.name == 'numeroDocumentoRepLegal'
      );

    if (!this.idTipoDocumentoDemandantePJ) {
      this.idTipoDocumentoDemandantePJ = documentType;
    }

    documentNumber?.clearValidators();
    if (documentType == 4) {
      if (numeroDocumentoRepLegalDemandandante != undefined) {
        documentNumber?.setValidators([
          Validators.required,
          Validators.maxLength(8),
          Validators.minLength(4),
          Validators.pattern(
            Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
          ),
        ]);
        numeroDocumentoRepLegalDemandandante.errorMessages!['maxlength'] =
          this.comunText['numero-documento-maxlength-ce'];
        numeroDocumentoRepLegalDemandandante.errorMessages!['minlength'] =
          this.comunText['numero-documento-minlength'];
        numeroDocumentoRepLegalDemandandante.errorMessages!['pattern'] =
          this.comunText['numero-documento-pattern-ce'];
      }
    } else {
      if (numeroDocumentoRepLegalDemandandante != undefined) {
        documentNumber?.setValidators([
          Validators.required,
          Validators.maxLength(12),
          Validators.minLength(4),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ]);
        numeroDocumentoRepLegalDemandandante.errorMessages!['maxlength'] =
          this.comunText['numero-documento-maxlength'];
        numeroDocumentoRepLegalDemandandante.errorMessages!['minlength'] =
          this.comunText['numero-documento-minlength'];
        numeroDocumentoRepLegalDemandandante.errorMessages!['pattern'] =
          this.comunText['numero-documento-pattern'];
      }
    }
    this.idTipoDocumentoDemandantePJ = documentType;

    if (formGroup?.invalid) {
      this.personaJuridicaDemandanteValida = false;
    } else {
      this.personaJuridicaDemandanteValida = true;
    }

    if (!this.firstTime) {
      this.subscribeToPaisPersonaJuridicaDemandante(formGroup);
      this.firstTime = true;
    }
    this.validarIdentificacionesActores();
  }

  changeControlPersonaJuridicaDemandante(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    if (event.controlName == 'country') {
      this.validarPaisDeptoMuni(event.form, '');
    }
    if (event.controlName == 'countryRepLegal') {
      this.validarPaisDeptoMuni(event.form, 'RepLegal');
    }

  }

  // valida que al cambiar el formulario para apoderado el mismo sea valido
  onChangeApodeardoTramite(formGroup: FormGroup) {
    this.formGroupApoderadoTramite = formGroup;
    if (
      this.formGroupApoderadoTramite?.get('primerNombre')?.value !== undefined ||
      this.formGroupApoderadoTramite?.get('primerApellido')?.value !== undefined
    ) {
      const primerNombreInput = document.getElementById('primerNombre');
      const primerApellidoInput = document.getElementById('primerApellido');
      if (this.formGroupApoderadoTramite.get('primerNombre')?.valid) {
        primerNombreInput?.classList.remove('ng-valid');
        primerNombreInput?.classList.add('autocompleted');
      }
      if (this.formGroupApoderadoTramite.get('primerApellido')?.valid) {
        primerApellidoInput?.classList.remove('ng-valid');
        primerApellidoInput?.classList.add('autocompleted');
      }
    }
    const documentType =
      this.formGroupApoderadoTramite?.get('typeOfDocument')?.value;
    const documentNumber =
      this.formGroupApoderadoTramite?.get('numeroDocumento');
    const numeroDocumentoApoderado = this.formApoderadoTramite.find(
      field => field.name == 'numeroDocumento'
    );

    if (!this.idTipoDocumentoApoderado) {
      this.idTipoDocumentoApoderado = documentType;
    }

    if (this.idTipoDocumentoApoderado != documentType) {
      documentNumber?.setValue('');
      documentNumber?.clearValidators();
      if (documentType == 4) {
        if (numeroDocumentoApoderado != undefined) {
          documentNumber?.setValidators([
            Validators.required,
            Validators.maxLength(8),
            Validators.minLength(4),
            Validators.pattern(
              Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
            ),
          ]);
          numeroDocumentoApoderado.errorMessages!['minlength'] =
            this.comunText['numero-documento-minlength-ce'];
          numeroDocumentoApoderado.errorMessages!['maxlength'] =
            this.comunText['numero-documento-maxlength-ce'];
          numeroDocumentoApoderado.errorMessages!['pattern'] =
            this.comunText['numero-documento-pattern-ce'];
        }
      } else {
        if (numeroDocumentoApoderado != undefined) {
          documentNumber?.setValidators([
            Validators.maxLength(12),
            Validators.minLength(4),
            Validators.pattern(Constants.REGEX_TELEFONO),
          ]);
          numeroDocumentoApoderado.errorMessages!['maxlength'] =
            this.comunText['numero-documento-maxlength'];
          numeroDocumentoApoderado.errorMessages!['minlength'] =
            this.comunText['numero-documento-minlength'];
          numeroDocumentoApoderado.errorMessages!['pattern'] =
            this.comunText['numero-documento-pattern'];
        }
      }
      this.idTipoDocumentoApoderado = documentType;
    } else {
      if (documentType == 4) {
        if (numeroDocumentoApoderado != undefined) {
          documentNumber?.setValidators([
            Validators.required,
            Validators.minLength(4),
            Validators.maxLength(8),
            Validators.pattern(
              Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
            ),
          ]);
          numeroDocumentoApoderado.errorMessages!['minlength'] =
            this.comunText['numero-documento-minlength-ce'];
          numeroDocumentoApoderado.errorMessages!['maxlength'] =
            this.comunText['numero-documento-maxlength-ce'];
          numeroDocumentoApoderado.errorMessages!['pattern'] =
            this.comunText['numero-documento-pattern-ce'];
        }
      } else {
        if (numeroDocumentoApoderado != undefined) {
          documentNumber?.setValidators([
            Validators.required,
            Validators.maxLength(12),
            Validators.minLength(4),
            Validators.pattern(Constants.REGEX_TELEFONO),
          ]);
          numeroDocumentoApoderado.errorMessages!['maxlength'] =
            this.comunText['numero-documento-maxlength'];
          numeroDocumentoApoderado.errorMessages!['minlength'] =
            this.comunText['numero-documento-minlength'];
          numeroDocumentoApoderado.errorMessages!['pattern'] =
            this.comunText['numero-documento-pattern'];
        }
      }
    }
    if (formGroup?.get('country')?.value != 1) {
      this.formApoderadoTramite.forEach(field => {
        if (field.name === 'otroDepartamento' || field.name === 'otroMunicipio') {
          field.required = true;
        }
      })
    }
    this.validarPersona('Apoderado');
    if (formGroup?.invalid) {
      this.apoderadoTramiteValida = false;
    } else {
      this.apoderadoTramiteValida = true;
    }
    this.validarIdentificacionesActores();
  }

  changeApoderadoTramite(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    if (event.controlName == 'country') {
      this.validarPaisDeptoMuni(event.form, '');
    }

  }

  // valida que al cambiar el formulario para demandado persona natural el mismo sea valido
  onChangePersonaNaturalDemandado(formGroup: FormGroup) {
    this.demandadoAux = formGroup?.value;
    this.formGroupPersonaNaturalDemandada = formGroup;
    if (formGroup?.get('country')?.value != 1) {
      this.formPersonaNaturalDemandada.forEach(field => {
        if (field.name === 'otroDepartamento' || field.name === 'otroMunicipio') {
          field.required = true;
        }
      })
    }
    const documentType =
      this.formGroupPersonaNaturalDemandada?.get('typeOfDocument')?.value;
    const documentNumber =
      this.formGroupPersonaNaturalDemandada?.get('numeroDocumento');
    const numeroDocumentoDemandandado = this.formPersonaNaturalDemandada.find(
      field => field.name == 'numeroDocumento'
    );

    if (!this.idTipoDocumentoDemandadoPN) {
      this.idTipoDocumentoDemandadoPN = documentType;
    }

    if (this.idTipoDocumentoDemandadoPN != documentType) {
      documentNumber?.setValue('');
      documentNumber?.clearValidators();
      if (documentType == 4) {
        if (numeroDocumentoDemandandado != undefined) {
          documentNumber?.setValidators([
            Validators.required,
            Validators.maxLength(8),
            Validators.minLength(4),
            Validators.pattern(
              Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
            ),
          ]);
          numeroDocumentoDemandandado.errorMessages!['minlength'] =
            this.comunText['numero-documento-minlength-ce'];
          numeroDocumentoDemandandado.errorMessages!['maxlength'] =
            this.comunText['numero-documento-maxlength-ce'];
          numeroDocumentoDemandandado.errorMessages!['pattern'] =
            this.comunText['numero-documento-pattern-ce'];
        }
      } else {
        if (numeroDocumentoDemandandado != undefined) {
          documentNumber?.setValidators([
            Validators.required,
            Validators.maxLength(12),
            Validators.minLength(4),
            Validators.pattern(Constants.REGEX_TELEFONO),
          ]);
          numeroDocumentoDemandandado.errorMessages!['maxlength'] =
            this.comunText['numero-documento-maxlength'];
          numeroDocumentoDemandandado.errorMessages!['minlength'] =
            this.comunText['numero-documento-minlength'];
          numeroDocumentoDemandandado.errorMessages!['pattern'] =
            this.comunText['numero-documento-pattern'];
        }
      }
      this.idTipoDocumentoDemandadoPN = documentType;
    } else {
      if (documentType == 4) {
        if (numeroDocumentoDemandandado != undefined) {
          documentNumber?.setValidators([
            Validators.required,
            Validators.minLength(4),
            Validators.maxLength(8),
            Validators.pattern(
              Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
            ),
          ]);
          numeroDocumentoDemandandado.errorMessages!['minlength'] =
            this.comunText['numero-documento-minlength-ce'];
          numeroDocumentoDemandandado.errorMessages!['maxlength'] =
            this.comunText['numero-documento-maxlength-ce'];
          numeroDocumentoDemandandado.errorMessages!['pattern'] =
            this.comunText['numero-documento-pattern-ce'];
        }
      } else {
        if (numeroDocumentoDemandandado != undefined) {
          documentNumber?.setValidators([
            Validators.required,
            Validators.maxLength(12),
            Validators.minLength(4),
            Validators.pattern(Constants.REGEX_TELEFONO),
          ]);
          numeroDocumentoDemandandado.errorMessages!['maxlength'] =
            this.comunText['numero-documento-maxlength'];
          numeroDocumentoDemandandado.errorMessages!['minlength'] =
            this.comunText['numero-documento-minlength'];
          numeroDocumentoDemandandado.errorMessages!['pattern'] =
            this.comunText['numero-documento-pattern'];
        }
      }
    }

    if (formGroup?.invalid) {
      this.personaNaturalDemandadaValida = false;
    } else {
      this.personaNaturalDemandadaValida = true;
    }
    this.validarPersona('Demandado');
    this.validarIdentificacionesActores();
  }

  changePersonaNaturalDemandado(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    if (event.controlName == 'country') {
      this.validarPaisDeptoMuni(event.form, '');
    }
  }

  // valida que al cambiar el formulario para demandado persona juridica el mismo sea valido
  onChangePersonaJuridicaDemandado(formGroup: FormGroup) {
    this.demandadoAux = formGroup?.value;
    this.formGroupPersonaJuridicaDemandada = formGroup;
    if (formGroup?.get('country')?.value != 1) {
      this.formPersonaJuridicaDemandada.forEach(field => {
        if (field.name === 'otroDepartamento' || field.name === 'otroMunicipio') {
          field.required = true;
        }
      })
    }
    if (formGroup?.invalid) {
      this.personaJuridicaDemandadaValida = false;
    } else {
      this.personaJuridicaDemandadaValida = true;
    }
    this.validarIdentificacionesActores();
  }

  changePersonaJuridicaDemandado(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    if (event.controlName == 'country') {
      this.validarPaisDeptoMuni(event.form, '');
    }
  }

  // valida que al cambiar el formulario de la solicitud del tramite mismo sea valido
  onChangeDetalleSolicitud(formGroup: FormGroup) {
    this.validarPaisDeptoMuni(formGroup, '');
    this.formGroupInformacionTramite = formGroup;
    if (this.formGroupInformacionTramite?.invalid) {
      this.solicitudTramiteValida = false;
    } else {
      this.solicitudTramiteValida = true;
    }
  }

  changeDetalleSolicitud(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    if (event.controlName == 'country') {
      this.validarPaisDeptoMuni(event.form, '');
    }
  }

  // Este metodo realiza el submit del formulario completo
  onSubmitCompiladoFormularios(esEnviar: boolean) {
    if (!this.archivosValidos) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['archivos_obligatorios']
      );
      return;
    }

    if (this.validacionTodosFormularios()) {
      this.markFormsAsTouched();
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }

    if (!this.confirmacionEnvio) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['ley_2213']
      );
      return;
    }
    if (!this.seleccionAceptoRechazoEnvio) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['envio_demanda']
      );
      return;
    }
    this.enviarEntidad = esEnviar;
    const tramite = this.buildRequestCrecionTramite(esEnviar);
    const body = {
      ...tramite,
      enviarCorreoDemandado: this.enviarCorreoDemandado ?? false,
      idioma: this.idiomaActual,
    };

    if (!this.validacionFormularios()) {
      this.tramiteIcaService.crearTramiteVariedadVegetal(body).subscribe(
        response => {
          if (response.data === null) {
            this.alertaModalService.exito(
              this.alertaText['proceso-guardado-exitosamente']
            );
          }
          this.idTramite = response.data.Id;

          if (this.idTramite) {
            this.idTramiteObtentorVariedadVegetal = this.idTramite;
            this.enviarDocumentos = true;
          }
          if (esEnviar) {
            const mensajeConEntidad = this.alertaText['ica-alertas']['tramite-enviado'].replace('{{entidad}}', this.entidad);
            this.alertaModalService
              .exito(
                this.alertaText['proceso-enviado'],
                mensajeConEntidad
              )
              .then(() => {
                this.router.navigate(['/expediente']);
              });
          }
        },
        err => {
          console.error(err);
        }
      );
    } else {
    }
  }

  // Este metodo realiza la construcción del request para el guardado de toda la información
  buildRequestCrecionTramite(esEnviar: boolean): TramiteIcaVariedadVegetalDto {
    const request: TramiteIcaVariedadVegetalDto = {};

    let apoderado: PersonaDto = {};
    let demandante: PersonaDto = {};
    let demandado: PersonaDto = {};
    let representanteLegal: PersonaDto = {};
    // if (this.tipoPersonaDemandanteValida) {
    //   this.disableAllControls(this.formGroupTipoPersonaDemandante);
    // }

    // if (this.tipoPersonaDemandadaValida) {
    //   this.disableAllControls(this.formGroupTipoPersonaDemandada);
    // }
    if (this.formGroupApoderadoTramite.valid) {
      apoderado = {
        id: this.idApoderado ? this.idApoderado : null,
        idTipoPersona: 1,
        idTipoIdentificacion:
          this.formGroupApoderadoTramite.value['typeOfDocument'],
        identificacion: this.formGroupApoderadoTramite.value['numeroDocumento'],
        primerNombre: this.formGroupApoderadoTramite.value['primerNombre'],
        segundoNombre: this.formGroupApoderadoTramite.value['segundoNombre'],
        primerApellido: this.formGroupApoderadoTramite.value['primerApellido'],
        segundoApellido:
          this.formGroupApoderadoTramite.value['segundoApellido'],
        tarjetaProfesional:
          this.formGroupApoderadoTramite.value['tarjetaProfesional'],
        correoElectronico: this.formGroupApoderadoTramite.value['email'],
        esApoderado: true,
        direccionPersona: [
          {
            direccionNotificacion:
              this.formGroupApoderadoTramite.value['direccionNotificacion'],
          },
        ],
        municipio: {
          id: this.formGroupApoderadoTramite.value['municipality'],
        },
        otroDepartamento:
          this.formGroupApoderadoTramite.value['otroDepartamento'],
        otroMunicipio: this.formGroupApoderadoTramite.value['otroMunicipio'],
        telefonoPrincipal: this.formGroupApoderadoTramite.value['telefono'],
      };
      // this.disableAllControls(this.formGroupApoderadoTramite);
    }

    if (this.validacionPersonaDemandado()) {
      if (this.tipoPersonaDemandanda == 1) {
        demandado = {
          id: this.idDemandado ? this.idDemandado : null,
          idTipoPersona: 1,
          idTipoIdentificacion: Number(
            this.formGroupPersonaNaturalDemandada.value['typeOfDocument']
          ),
          identificacion:
            this.formGroupPersonaNaturalDemandada.value['numeroDocumento'],
          direccionPersona: [
            {
              direccionNotificacion:
                this.formGroupPersonaNaturalDemandada.value[
                'direccionNotificacion'
                ],
            },
          ],
          fechaNacimiento:
            this.formGroupPersonaNaturalDemandada.value['fechaNacimiento'],
          municipio: {
            id: Number(
              this.formGroupPersonaNaturalDemandada.value['municipality']
            ),
          },
          otroDepartamento:
            this.formGroupPersonaNaturalDemandada.value['otroDepartamento'],
          otroMunicipio:
            this.formGroupPersonaNaturalDemandada.value['otroMunicipio'],
          correoElectronico:
            this.formGroupPersonaNaturalDemandada.value['email'],
          primerNombre:
            this.formGroupPersonaNaturalDemandada.value['primerNombre'],
          segundoNombre:
            this.formGroupPersonaNaturalDemandada.value['segundoNombre'],
          primerApellido:
            this.formGroupPersonaNaturalDemandada.value['primerApellido'],
          segundoApellido:
            this.formGroupPersonaNaturalDemandada.value['segundoApellido'],
        };

        // this.disableAllControls(this.formGroupPersonaNaturalDemandada);
      } else {
        const item = this.listaTipoSociedad.find(
          item =>
            item.Id ===
            this.formGroupPersonaJuridicaDemandada.value['tipoSociedad']
        );

        const tipoSociedad: ListaValorRequestDto = {
          valor: item?.Valor,
          estado: item?.Estado,
          nombreLista: item?.Nombre_Lista,
          codigo: item?.Codigo,
          otroValor: item?.Otro_valor,
          idExterno: item?.Id_Externo,
          id: item?.Id,
        };

        demandado = {
          id: this.idDemandado ? this.idDemandado : null,
          idTipoPersona: 2,
          idTipoIdentificacion:
            this.formGroupPersonaJuridicaDemandada.value['idTipoIdentificacion'],
          razonSocial:
            this.formGroupPersonaJuridicaDemandada.value['razonSocial'],
          identificacion:
            this.formGroupPersonaJuridicaDemandada.value['numeroDocumentoNit'],
          correoElectronico:
            this.formGroupPersonaJuridicaDemandada.value['email'],
          municipio: {
            id: this.formGroupPersonaJuridicaDemandada.value['municipality'],
          },
          otroDepartamento:
            this.formGroupPersonaJuridicaDemandada.value['otroDepartamento'],
          otroMunicipio:
            this.formGroupPersonaJuridicaDemandada.value['otroMunicipio'],
          direccionPersona: [
            {
              direccionNotificacion:
                this.formGroupPersonaJuridicaDemandada.value[
                'direccionNotificacion'
                ],
            },
          ],
          tipoSociedad: tipoSociedad,
        };
        // this.disableAllControls(this.formGroupPersonaJuridicaDemandada);
      }
    }

    if (this.validacionPersonaDemandante()) {
      if (this.tipoPersonaDemandante == 1) {
        demandante = {
          id: this.idDemandante ? this.idDemandante : null,
          idTipoPersona: this.tipoPersonaDemandante,
          idTipoIdentificacion: Number(
            this.formGroupPersonaNaturalDemandante.value['typeOfDocument']
          ),
          identificacion:
            this.formGroupPersonaNaturalDemandante.value['numeroDocumento'],
          direccionPersona: [
            {
              direccionNotificacion:
                this.formGroupPersonaNaturalDemandante.value[
                'direccionNotificacion'
                ],
            },
          ],
          fechaNacimiento:
            this.formGroupPersonaNaturalDemandante.value['fechaNacimiento'],
          telefonoPrincipal:
            this.formGroupPersonaNaturalDemandante.value['phone'],
          municipio: {
            id: Number(
              this.formGroupPersonaNaturalDemandante.value['municipality']
            ),
          },
          otroDepartamento:
            this.formGroupPersonaNaturalDemandante.value['otroDepartamento'],
          otroMunicipio:
            this.formGroupPersonaNaturalDemandante.value['otroMunicipio'],
          correoElectronico:
            this.formGroupPersonaNaturalDemandante.value['email'],
          primerNombre:
            this.formGroupPersonaNaturalDemandante.value['primerNombre'],
          segundoNombre:
            this.formGroupPersonaNaturalDemandante.value['segundoNombre'],
          primerApellido:
            this.formGroupPersonaNaturalDemandante.value['primerApellido'],
          segundoApellido:
            this.formGroupPersonaNaturalDemandante.value['segundoApellido'],
        };
        // this.disableAllControls(this.formGroupPersonaNaturalDemandante);
      } else {
        representanteLegal = {
          id: this.idRepresentante ? this.idRepresentante : null,
          idTipoPersona: 1,
          primerNombre:
            this.formGroupPersonaJuridicaDemandante.value[
            'primeroNombreRepLegal'
            ],
          segundoNombre:
            this.formGroupPersonaJuridicaDemandante.value[
            'segundoNombreRepLegal'
            ],
          primerApellido:
            this.formGroupPersonaJuridicaDemandante.value[
            'primerApellidoRepLegal'
            ],
          segundoApellido:
            this.formGroupPersonaJuridicaDemandante.value[
            'segundoApellidoRepLegal'
            ],
          idTipoIdentificacion:
            +this.formGroupPersonaJuridicaDemandante.value['typeOfDocument'],
          identificacion:
            this.formGroupPersonaJuridicaDemandante.value[
            'numeroDocumentoRepLegal'
            ],
          correoElectronico:
            this.formGroupPersonaJuridicaDemandante.value['emailRepLegal'],
          direccionPersona: [
            {
              direccionNotificacion:
                this.formGroupPersonaJuridicaDemandante.value[
                'direccionNotificacion'
                ],
            },
          ],
          municipio: {
            id: this.formGroupPersonaJuridicaDemandante.value[
              'municipalityRepLegal'
            ],
          },
          otroDepartamento:
            this.formGroupPersonaJuridicaDemandante.value['otroDepartamento'],
          otroMunicipio:
            this.formGroupPersonaJuridicaDemandante.value['otroMunicipio'],
        };

        const item = this.listaTipoSociedad.find(
          item =>
            item.Id ===
            this.formGroupPersonaJuridicaDemandante?.value['tipoSociedad']
        );

        const tipoSociedad: ListaValorRequestDto = {
          valor: item?.Valor,
          estado: item?.Estado,
          nombreLista: item?.Nombre_Lista,
          codigo: item?.Codigo,
          otroValor: item?.Otro_valor,
          idExterno: item?.Id_Externo,
          id: item?.Id,
        };

        demandante = {
          id: this.idDemandante ? this.idDemandante : null,
          idTipoPersona: 2,
          idTipoIdentificacion:
            this.formGroupPersonaJuridicaDemandante.value['idTipoIdentificacion'],
          razonSocial:
            this.formGroupPersonaJuridicaDemandante.value['razonSocial'],
          identificacion:
            this.formGroupPersonaJuridicaDemandante.value['numeroDocumentoNit'],
          correoElectronico:
            this.formGroupPersonaJuridicaDemandante.value['email'],
          municipio: {
            id: this.formGroupPersonaJuridicaDemandante.value['municipality'],
          },
          otroDepartamento:
            this.formGroupPersonaJuridicaDemandante.value['otroDepartamento'],
          otroMunicipio:
            this.formGroupPersonaJuridicaDemandante.value['otroMunicipio'],
          direccionPersona: [
            {
              direccionNotificacion:
                this.formGroupPersonaJuridicaDemandante.value['address'],
            },
          ],
          datosRepresentanteLegal: representanteLegal,
          tipoSociedad: tipoSociedad,
        };
        // this.disableAllControls(this.formGroupPersonaJuridicaDemandante);
      }
    }

    const item = this.listaTipoEspecieIca.find(
      item =>
        item.Id === this.formGroupInformacionTramite?.value['tipoDeEspecie']
    );

    const listaValor: ListaValorRequestDto = {
      valor: item?.Valor,
      estado: item?.Estado,
      nombreLista: item?.Nombre_Lista,
      codigo: item?.Codigo,
      otroValor: item?.Otro_valor,
      idExterno: item?.Id_Externo,
      id: item?.Id,
    };

    if (this.formGroupInformacionTramite.valid) {
      request.tipoEspecie = listaValor;
      request.nombreEspecie =
        this.formGroupInformacionTramite.value['nombreEspecie'];
      request.variedadVegetal =
        this.formGroupInformacionTramite.value['denominacionVariedadVegetal'];
      request.municipio = {
        id: this.formGroupInformacionTramite.value['municipality'],
      };
      request.otroDepartamento =
        this.formGroupInformacionTramite.value['otroDepartamento'];
      request.otroMunicipio =
        this.formGroupInformacionTramite.value['otroMunicipio'];
      request.apoderado = apoderado;
      request.tieneApoderado = true;
      request.demandante = [demandante];
      request.demandado = [demandado];
      request.enviar = esEnviar;
      request.id = this.idTramiteObtentorVariedadVegetal ?? null;
      // this.disableAllControls(this.formGroupInformacionTramite);
    }

    return request;
  }

  // Este metodo es para validación del formulario de demandado y devuelve si es valido o no
  // sea persona natural o juridica
  validacionPersonaDemandado(): boolean {
    if (this.tipoPersonaDemandanda == 1) {
      return this.formGroupPersonaNaturalDemandada?.valid;
    } else {
      return this.formGroupPersonaJuridicaDemandada?.valid;
    }
  }

  // Este metodo es para validación del formulario de demandante y devuelve si es valido o no
  // sea persona natural o juridica
  validacionPersonaDemandante(): boolean {
    if (this.tipoPersonaDemandante == 1) {
      return this.formGroupPersonaNaturalDemandante?.valid;
    } else {
      return this.formGroupPersonaJuridicaDemandante?.valid;
    }
  }

  // Metodo que valida que todos los formularios de la pagina sean validos
  validacionFormularios(): boolean {
    return !(
      (this.solicitudTramiteValida && this.apoderadoTramiteValida) ||
      this.validacionPersonaDemandado() ||
      this.validacionPersonaDemandante()
    );
  }

  // Metodo que valida que todos los formularios de la pagina sean validos
  validacionTodosFormularios(): boolean {
    if (this.tipoPersonaDemandante == 2) {
      if (this.formGroupPersonaJuridicaDemandante) {
        // Demandante PJ
        this.setValidadorPais(this.formGroupPersonaJuridicaDemandante, 'country');
        // Representante PJ
        this.setValidadorPais(this.formGroupPersonaJuridicaDemandante, undefined, 'countryRepLegal');
      }
    } else {
      if (this.formGroupPersonaNaturalDemandante) {
        this.setValidadorPais(this.formGroupPersonaNaturalDemandante, 'country');
      }
    }
    if (this.formGroupApoderadoTramite) {
      this.setValidadorPais(this.formGroupApoderadoTramite, 'country');
    }
    if (this.tipoPersonaDemandanda == 1) {
      if (this.formGroupPersonaNaturalDemandada) {
        this.setValidadorPais(this.formGroupPersonaNaturalDemandada, 'country');
      }
    } else {
      if (this.formGroupPersonaJuridicaDemandada) {
        this.setValidadorPais(this.formGroupPersonaJuridicaDemandada, 'country');
      }
    }
    return !(
      this.formGroupInformacionTramite?.valid &&
      this.formGroupApoderadoTramite?.valid &&
      this.validacionPersonaDemandado() &&
      this.validacionPersonaDemandante() &&
      this.archivosValidos
    );
  }

  // Metodo que realiza una suscripción al cambio de los valores de pais y departamento en el formulario
  // de demandante y poder cambiar los valores a demanda del usuario
  private subscribeToPaisPersonaJuridicaDemandante(fromGroup: FormGroup): void {
    fromGroup
      ?.get('countryRepLegal')
      ?.valueChanges.subscribe(value => this.getDepartments(value));
    if (fromGroup
      ?.get('countryRepLegal')?.value == 1) {
      fromGroup
        ?.get('departamentRepLegal')
        ?.valueChanges.subscribe(value => this.getMunicipalities(value));
    }

  }

  // Metodo que llama al servicio de paises y hace el llenado de info en el formulario
  getCountries(): void {
    const paisRepLegalDemandandante = this.formPersonaJuridicaDemandante.find(
      field => field.name == 'countryRepLegal'
    );
    this.listasService.getCountryList().subscribe((countries: PaisDto[]) => {
      this.paises = countries;
      const formattedCountries = countries.map(country => ({
        Id: country.Id,
        Nombre: country.Nombre,
        Codigo: country.Codigo,
      }));
      if (paisRepLegalDemandandante != undefined) {
        paisRepLegalDemandandante.options = formattedCountries;
      }
    });
  }

  // Metodo que llama al servicio de departamento con el parametro del pais y llena la info en el formulario
  getDepartments(idCountry: number): void {
    const paisRepLegalDemandandante = this.formPersonaJuridicaDemandante.find(
      field => field.name == 'departamentRepLegal'
    );
    if (idCountry == 1) {
      this.listasService
        .getDepartmentList(idCountry)
        .subscribe((departments: DepartmentoDto[]) => {
          const formattedDepartments = departments.map(department => ({
            Id: department.Id,
            Nombre: department.Nombre,
          }));
          if (paisRepLegalDemandandante != undefined) {
            paisRepLegalDemandandante.options = formattedDepartments;
          }
        });
    }

  }

  // Metodo que llama al servicio de municipio con el parametro del departamento y llena la info en el formulario
  getMunicipalities(idDepartment: number): void {
    const paisRepLegalDemandandante = this.formPersonaJuridicaDemandante.find(
      field => field.name == 'municipalityRepLegal'
    );
    this.listasService
      .getMunicipalityList(idDepartment)
      .subscribe((municipalities: MunicipioDto[]) => {
        const formattedMunicipalities = municipalities.map(municipalities => ({
          Id: municipalities.Id,
          Nombre: municipalities.Nombre,
        }));
        if (paisRepLegalDemandandante != undefined) {
          paisRepLegalDemandandante.options = formattedMunicipalities;
        }
      });
  }

  // Metodo para deshabilitar los inputs de un formulario que ya fue validado
  disableAllControls(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      formGroup.controls[key].disable();
    });
  }

  getDataUsuario() {
    this.dataUsuario = this.textTransformService.transformarAMayusculas(this.dataUsuario);
    const user_type = JSON.parse(sessionStorage.getItem(Constants.USER_TYPE) ?? '{}');

    if (user_type.Nombre == 'Abogado') {
      if (this.dataUsuario) {
        this.getData(this.dataUsuario?.idPersona!);
      }
    } else {
      this.mapearDatosTipoDemandante(this.dataUsuario?.tipoPersona!);

      const esNatural = this.dataUsuario?.tipoPersona == Constants.TIPO_PERSONA.NATURAL;

      const persona: PersonaDto = esNatural
        ? {
          primerNombre: this.dataUsuario?.primerNombre,
          segundoNombre: this.dataUsuario?.segundoNombre,
          primerApellido: this.dataUsuario?.primerApellido,
          segundoApellido: this.dataUsuario?.segundoApellido,
          typeOfDocument: this.getIdDocumento(String(this.dataUsuario?.tipoDocumento)),
          numeroDocumento: +this.dataUsuario?.identificacion!,
          email: this.dataUsuario?.correoElectronico,
          country: this.dataUsuario?.pais,
          departament: this.dataUsuario?.departamento,
          municipality: this.dataUsuario?.municipio,
          fechaNacimiento: this.dataUsuario?.fechaNacimiento,
          otroDepartamento: this.dataUsuario?.otroDepartamento,
          otroMunicipio: this.dataUsuario?.otroMunicipio,
          direccionNotificacion: this.dataUsuario?.direccion?.find(e => e.Es_Primaria)?.Direccion_Notificacion ?? '',
        }
        : {
          razonSocial: this.dataUsuario?.razonSocial,
          idTipoIdentificacion: Number(Constants.NIT_ID),
          typeOfDocument: this.getIdDocumento(String(this.dataUsuario?.tipoDocumento)),
          numeroDocumento: this.dataUsuario?.identificacion,
          email: this.dataUsuario?.correoElectronico,
          country: this.dataUsuario?.pais,
          departament: this.dataUsuario?.departamento,
          municipality: this.dataUsuario?.municipio,
          otroDepartamento: this.dataUsuario?.otroDepartamento,
          otroMunicipio: this.dataUsuario?.otroMunicipio,
          address: this.dataUsuario?.direccion?.find(e => e.Es_Primaria)?.Direccion_Notificacion ?? '',
        };

      // Si es extranjero, primero obtenemos los datos y luego mapeamos
      if (persona.country !== 1) {
        this._cuentaService.getDataPersonal(this.dataUsuario!.idUsuario!).subscribe((response: any) => {
          persona.otroDepartamento = response.data.Otro_Departamento;
          persona.otroMunicipio = response.data.Otro_Municipio;

          if (esNatural) {
            this.mapearDatosPersonaNatural(persona);
          } else {
            this.mapearDatosPersonaJuridica(persona);
          }
        });
      } else {
        // Si es nacional, mapeamos de una vez
        if (esNatural) {
          this.mapearDatosPersonaNatural(persona);
        } else {
          this.mapearDatosPersonaJuridica(persona);
        }
      }
    }
  }

  getData(idPersona: number) {
    this.datosProvisionalesService.getDataAbogado(idPersona).subscribe((responseAbogado: any) => {
      const tarjeta = responseAbogado.datoAdicionalAbogado.Tarjeta_Profesional;

      if (this.dataUsuario?.pais !== 1) {
        this._cuentaService.getDataPersonal(this.dataUsuario!.idUsuario!).subscribe((responseExtranjero: any) => {
          const otroDep = responseExtranjero.data.Otro_Departamento;
          const otroMun = responseExtranjero.data.Otro_Municipio;

          this.mapearFormulario(tarjeta, otroDep, otroMun);
        });
      } else {
        this.mapearFormulario(tarjeta, this.dataUsuario?.otroDepartamento, this.dataUsuario?.otroMunicipio);
      }
    });
  }

  private mapearFormulario(tarjeta: number, otroDepartamento: string | undefined, otroMunicipio: string | undefined) {
    setTimeout(() => {
      this.formApoderadoTramite = this.formApoderadoTramite.map(
        (field: FormField) => {
          switch (field.name) {
            case 'primerNombre':
              field.value = this.dataUsuario?.primerNombre ?? undefined;
              break;
            case 'segundoNombre':
              field.value = this.dataUsuario?.segundoNombre ?? undefined;
              break;
            case 'primerApellido':
              field.value = this.dataUsuario?.primerApellido ?? undefined;
              break;
            case 'segundoApellido':
              field.value = this.dataUsuario?.segundoApellido ?? undefined;
              break;
            case 'typeOfDocument':
              field.value = this.getIdDocumento(
                String(this.dataUsuario?.tipoDocumento)
              ) ?? undefined;
              break;
            case 'numeroDocumento':
              field.value = this.dataUsuario?.identificacion ?? undefined;
              break;
            case 'country':
              field.value = this.dataUsuario?.pais ?? undefined;
              break;
            case 'departament':
              field.value = this.dataUsuario?.departamento ?? undefined;
              break;
            case 'municipality':
              field.value = this.dataUsuario?.municipio ?? undefined;
              break;
            case 'otroDepartamento':
              field.value = otroDepartamento ?? undefined;
              break;
            case 'otroMunicipio':
              field.value = otroMunicipio ?? undefined;
              break;
            case 'email':
              field.value = this.dataUsuario?.correoElectronico ?? undefined;;
              break;
            case 'direccionNotificacion':
              field.value = this.dataUsuario?.direccion?.find(
                (elemento: {
                  Direccion_Notificacion?: string;
                  Es_Primaria?: boolean;
                  Id?: number
                }) => elemento.Es_Primaria
              )?.Direccion_Notificacion ??
                this.dataUsuario?.direccion?.[0]?.Direccion_Notificacion ?? '';
              break;
            case 'tarjetaProfesional':
              field.value = tarjeta ?? undefined;
              break;

          }
          return field;
        }
      );
    }, 800)
  }

  mapearDatosTipoDemandante(dataDemandante: number) {
    this.tipoPersonaDemandante = dataDemandante;
    this.formTipoPersonaDemandante = this.formTipoPersonaDemandante.map(
      field => {
        field.value = dataDemandante;
        return field;
      }
    );
  }

  mapearDatosPersonaNatural(dataPersona: PersonaDto) {
    setTimeout(() => {
      this.formPersonaNaturalDemandante = this.formPersonaNaturalDemandante.map(
        (field: FormField) => {
          switch (field.name) {
            case 'primerNombre':
              field.value = dataPersona.primerNombre;
              break;
            case 'segundoNombre':
              field.value = dataPersona.segundoNombre;
              break;
            case 'primerApellido':
              field.value = dataPersona.primerApellido;
              break;
            case 'segundoApellido':
              field.value = dataPersona.segundoApellido;
              break;
            case 'typeOfDocument':
              field.value = dataPersona.typeOfDocument;
              break;
            case 'fechaNacimiento':
              field.value = dataPersona.fechaNacimiento
                ?.toString()
                .split('T')[0];
              break;
            case 'numeroDocumento':
              field.value = dataPersona.numeroDocumento;
              break;
            case 'email':
              field.value = dataPersona.email;
              break;
            case 'country':
              field.value = dataPersona.country;
              break;
            case 'departament':
              field.value = dataPersona.departament;
              break;
            case 'municipality':
              field.value = dataPersona.municipality;
              break;
            case 'otroDepartamento':
              field.value = dataPersona.otroDepartamento;
              break;
            case 'otroMunicipio':
              field.value = dataPersona.otroMunicipio;
              break;
            case 'direccionNotificacion':
              field.value = dataPersona.direccionNotificacion;
              break;
          }
          return field;
        }
      );
    }, 800);
  }

  mapearDatosPersonaJuridica(dataPersona: PersonaDto) {
    setTimeout(() => {
      this.formPersonaJuridicaDemandante =
        this.formPersonaJuridicaDemandante.map((field: FormField) => {
          switch (field.name) {
            case 'razonSocial':
              field.value = dataPersona.razonSocial;
              break;
            case 'idTipoIdentificacion':
              field.value = Constants.NIT_ID;
              break;
            case 'numeroDocumentoNit':
              field.value = dataPersona.numeroDocumento;
              break;
            case 'email':
              field.value = dataPersona.email;
              break;
            case 'address':
              field.value = dataPersona.address;
              break;
            case 'country':
              field.value = dataPersona.country;
              break;
            case 'departament':
              field.value = dataPersona.departament;
              break;
            case 'municipality':
              field.value = dataPersona.municipality;
              break;
            case 'otroDepartamento':
              field.value = dataPersona.otroDepartamento;
              break;
            case 'otroMunicipio':
              field.value = dataPersona.otroMunicipio;
              break;
          }
          return field;
        });
    }, 800);
  }

  getIdDocumento(tipoDocumento: string): number {
    const documento = this.tiposDocumento.find(
      (elemento: TipoDocumentoDto) => elemento.Tipo_Documento === tipoDocumento
    );
    return documento ? +documento.Id : 0;
  }

  archivosValidados(event: boolean) {
    this.archivosValidos = event;
  }

  // Se construye el JSON para guardar el trámite sin enviarlo
  async onSubmitGuardar(): Promise<{ success: boolean; message?: string }> {
    try {
      const request: TramiteIcaVariedadVegetalDto = {};
      let apoderado: PersonaDto = {};
      let demandante: PersonaDto = {};
      let demandado: PersonaDto = {};
      let representanteLegal: PersonaDto = {};

      // Datos del apoderado
      apoderado = {
        id: this.idApoderado ? this.idApoderado : null,
        idTipoPersona: 1,
        idTipoIdentificacion: this.formGroupApoderadoTramite?.value[
          'typeOfDocument'
        ]
          ? this.formGroupApoderadoTramite?.value['typeOfDocument']
          : undefined,
        identificacion: this.formGroupApoderadoTramite?.value['numeroDocumento']
          ? this.formGroupApoderadoTramite?.value['numeroDocumento']
          : undefined,
        primerNombre: this.formGroupApoderadoTramite?.value['primerNombre']
          ? this.formGroupApoderadoTramite?.value['primerNombre']
          : undefined,
        segundoNombre: this.formGroupApoderadoTramite?.value['segundoNombre']
          ? this.formGroupApoderadoTramite?.value['segundoNombre']
          : undefined,
        primerApellido: this.formGroupApoderadoTramite?.value['primerApellido']
          ? this.formGroupApoderadoTramite?.value['primerApellido']
          : undefined,
        segundoApellido: this.formGroupApoderadoTramite?.value[
          'segundoApellido'
        ]
          ? this.formGroupApoderadoTramite?.value['segundoApellido']
          : undefined,
        tarjetaProfesional: this.formGroupApoderadoTramite?.value[
          'tarjetaProfesional'
        ]
          ? this.formGroupApoderadoTramite?.value['tarjetaProfesional']
          : undefined,
        correoElectronico: this.formGroupApoderadoTramite?.value['email']
          ? this.formGroupApoderadoTramite?.value['email']
          : undefined,
        esApoderado: true,
        direccionPersona: [
          {
            direccionNotificacion: this.formGroupApoderadoTramite?.value[
              'direccionNotificacion'
            ]
              ? this.formGroupApoderadoTramite?.value['direccionNotificacion']
              : undefined,
          },
        ],
        municipio: {
          id: this.formGroupApoderadoTramite?.value['municipality']
            ? this.formGroupApoderadoTramite?.value['municipality']
            : undefined,
          idPais: +this.formGroupApoderadoTramite?.value['country'],
          idDepartamento: +this.formGroupApoderadoTramite?.value['departament']
        },
        otroDepartamento: this.formGroupApoderadoTramite?.value[
          'otroDepartamento'
        ]
          ? this.formGroupApoderadoTramite?.value['otroDepartamento']
          : undefined,
        otroMunicipio: this.formGroupApoderadoTramite?.value['otroMunicipio']
          ? this.formGroupApoderadoTramite?.value['otroMunicipio']
          : undefined,
        telefonoPrincipal: this.formGroupApoderadoTramite?.value['telefono']
          ? this.formGroupApoderadoTramite?.value['telefono']
          : undefined,
      };

      // Datos del demandado
      if (this.tipoPersonaDemandanda == 1) {
        demandado = {
          id: this.idDemandado ? this.idDemandado : null,
          idTipoPersona: 1,
          idTipoIdentificacion: this.formGroupPersonaNaturalDemandada?.value[
            'typeOfDocument'
          ]
            ? Number(
              this.formGroupPersonaNaturalDemandada?.value['typeOfDocument']
            )
            : undefined,
          identificacion: this.formGroupPersonaNaturalDemandada?.value[
            'numeroDocumento'
          ]
            ? this.formGroupPersonaNaturalDemandada?.value['numeroDocumento']
            : undefined,
          direccionPersona: [
            {
              direccionNotificacion: this.formGroupPersonaNaturalDemandada
                ?.value['direccionNotificacion']
                ? this.formGroupPersonaNaturalDemandada?.value[
                'direccionNotificacion'
                ]
                : undefined,
            },
          ],
          fechaNacimiento: this.formGroupPersonaNaturalDemandada?.value[
            'fechaNacimiento'
          ]
            ? this.formGroupPersonaNaturalDemandada?.value['fechaNacimiento']
            : undefined,
          municipio: {
            id: Number(
              this.formGroupPersonaNaturalDemandada?.value['municipality']
                ? this.formGroupPersonaNaturalDemandada?.value['municipality']
                : undefined
            ),
            idPais: this.formGroupPersonaNaturalDemandada?.value['country'],
            idDepartamento: this.formGroupPersonaNaturalDemandada?.value['departament']
          },
          otroDepartamento: this.formGroupPersonaNaturalDemandada?.value[
            'otroDepartamento'
          ]
            ? this.formGroupPersonaNaturalDemandada?.value['otroDepartamento']
            : undefined,
          otroMunicipio: this.formGroupPersonaNaturalDemandada?.value[
            'otroMunicipio'
          ]
            ? this.formGroupPersonaNaturalDemandada?.value['otroMunicipio']
            : undefined,
          correoElectronico: this.formGroupPersonaNaturalDemandada?.value[
            'email'
          ]
            ? this.formGroupPersonaNaturalDemandada?.value['email']
            : this.formGroupPersonaNaturalDemandada?.value['email'],
          primerNombre: this.formGroupPersonaNaturalDemandada?.value[
            'primerNombre'
          ]
            ? this.formGroupPersonaNaturalDemandada?.value['primerNombre']
            : undefined,
          segundoNombre: this.formGroupPersonaNaturalDemandada?.value[
            'segundoNombre'
          ]
            ? this.formGroupPersonaNaturalDemandada?.value['segundoNombre']
            : undefined,
          primerApellido: this.formGroupPersonaNaturalDemandada?.value[
            'primerApellido'
          ]
            ? this.formGroupPersonaNaturalDemandada?.value['primerApellido']
            : undefined,
          segundoApellido: this.formGroupPersonaNaturalDemandada?.value[
            'segundoApellido'
          ]
            ? this.formGroupPersonaNaturalDemandada?.value['segundoApellido']
            : undefined,
        };
      } else {
        const item = this.listaTipoSociedad.find(
          item =>
            item.Id ===
            this.formGroupPersonaJuridicaDemandada?.value['tipoSociedad']
        );

        const tipoSociedad: ListaValorRequestDto = {
          valor: item?.Valor,
          estado: item?.Estado,
          nombreLista: item?.Nombre_Lista,
          codigo: item?.Codigo,
          otroValor: item?.Otro_valor,
          idExterno: item?.Id_Externo,
          id: item?.Id,
        };

        demandado = {
          id: this.idDemandado ? this.idDemandado : null,
          idTipoPersona: 2,
          idTipoIdentificacion: this.formGroupPersonaJuridicaDemandada?.value[
            'idTipoIdentificacion'
          ]
            ? this.formGroupPersonaJuridicaDemandada?.value['idTipoIdentificacion']
            : undefined,
          razonSocial: this.formGroupPersonaJuridicaDemandada?.value[
            'razonSocial'
          ]
            ? this.formGroupPersonaJuridicaDemandada?.value['razonSocial']
            : undefined,
          identificacion: this.formGroupPersonaJuridicaDemandada?.value[
            'numeroDocumentoNit'
          ]
            ? this.formGroupPersonaJuridicaDemandada?.value[
            'numeroDocumentoNit'
            ]
            : undefined,
          correoElectronico: this.formGroupPersonaJuridicaDemandada?.value[
            'email'
          ]
            ? this.formGroupPersonaJuridicaDemandada?.value['email']
            : undefined,
          municipio: {
            id: this.formGroupPersonaJuridicaDemandada?.value['municipality']
              ? this.formGroupPersonaJuridicaDemandada?.value['municipality']
              : undefined,
            idPais: this.formGroupPersonaJuridicaDemandada?.value['country'],
            idDepartamento: this.formGroupPersonaJuridicaDemandada?.value['departament']
          },
          otroDepartamento: this.formGroupPersonaJuridicaDemandada?.value[
            'otroDepartamento'
          ]
            ? this.formGroupPersonaJuridicaDemandada?.value['otroDepartamento']
            : undefined,
          otroMunicipio: this.formGroupPersonaJuridicaDemandada?.value[
            'otroMunicipio'
          ]
            ? this.formGroupPersonaJuridicaDemandada?.value['otroMunicipio']
            : undefined,
          direccionPersona: [
            {
              direccionNotificacion: this.formGroupPersonaJuridicaDemandada
                ?.value['direccionNotificacion']
                ? this.formGroupPersonaJuridicaDemandada?.value[
                'direccionNotificacion'
                ]
                : undefined,
            },
          ],
          tipoSociedad: tipoSociedad,
        };
      }

      // Datos del demandante
      if (this.tipoPersonaDemandante == 1) {
        demandante = {
          id: this.idDemandante ? this.idDemandante : null,
          idTipoPersona: this.tipoPersonaDemandante,
          idTipoIdentificacion: Number(
            this.formGroupPersonaNaturalDemandante?.value['typeOfDocument']
              ? this.formGroupPersonaNaturalDemandante?.value['typeOfDocument']
              : undefined
          ),
          identificacion: this.formGroupPersonaNaturalDemandante?.value[
            'numeroDocumento'
          ]
            ? this.formGroupPersonaNaturalDemandante?.value['numeroDocumento']
            : undefined,
          direccionPersona: [
            {
              direccionNotificacion: this.formGroupPersonaNaturalDemandante
                ?.value['direccionNotificacion']
                ? this.formGroupPersonaNaturalDemandante?.value[
                'direccionNotificacion'
                ]
                : undefined,
            },
          ],
          fechaNacimiento: this.formGroupPersonaNaturalDemandante?.value[
            'fechaNacimiento'
          ]
            ? this.formGroupPersonaNaturalDemandante?.value['fechaNacimiento']
            : undefined,
          telefonoPrincipal: this.formGroupPersonaNaturalDemandante?.value[
            'phone'
          ]
            ? this.formGroupPersonaNaturalDemandante?.value['phone']
            : undefined,
          municipio: {
            id: Number(
              this.formGroupPersonaNaturalDemandante?.value['municipality']
                ? this.formGroupPersonaNaturalDemandante?.value['municipality']
                : undefined
            ),
            idPais: this.formGroupPersonaNaturalDemandante?.value['country'],
            idDepartamento: this.formGroupPersonaNaturalDemandante?.value['departament']
          },
          otroDepartamento: this.formGroupPersonaNaturalDemandante?.value[
            'otroDepartamento'
          ]
            ? this.formGroupPersonaNaturalDemandante?.value['otroDepartamento']
            : undefined,
          otroMunicipio: this.formGroupPersonaNaturalDemandante?.value[
            'otroMunicipio'
          ]
            ? this.formGroupPersonaNaturalDemandante?.value['otroMunicipio']
            : undefined,
          correoElectronico: this.formGroupPersonaNaturalDemandante?.value[
            'email'
          ]
            ? this.formGroupPersonaNaturalDemandante?.value['email']
            : undefined,
          primerNombre: this.formGroupPersonaNaturalDemandante?.value[
            'primerNombre'
          ]
            ? this.formGroupPersonaNaturalDemandante?.value['primerNombre']
            : undefined,
          segundoNombre: this.formGroupPersonaNaturalDemandante?.value[
            'segundoNombre'
          ]
            ? this.formGroupPersonaNaturalDemandante?.value['segundoNombre']
            : undefined,
          primerApellido: this.formGroupPersonaNaturalDemandante?.value[
            'primerApellido'
          ]
            ? this.formGroupPersonaNaturalDemandante?.value['primerApellido']
            : undefined,
          segundoApellido: this.formGroupPersonaNaturalDemandante?.value[
            'segundoApellido'
          ]
            ? this.formGroupPersonaNaturalDemandante?.value['segundoApellido']
            : undefined,
        };
      } else {
        representanteLegal = {
          id: this.idRepresentante ? this.idRepresentante : null,
          idTipoPersona: 1,
          primerNombre: this.formGroupPersonaJuridicaDemandante?.value[
            'primeroNombreRepLegal'
          ]
            ? this.formGroupPersonaJuridicaDemandante?.value[
            'primeroNombreRepLegal'
            ]
            : undefined,
          segundoNombre: this.formGroupPersonaJuridicaDemandante?.value[
            'segundoNombreRepLegal'
          ]
            ? this.formGroupPersonaJuridicaDemandante?.value[
            'segundoNombreRepLegal'
            ]
            : undefined,
          primerApellido: this.formGroupPersonaJuridicaDemandante?.value[
            'primerApellidoRepLegal'
          ]
            ? this.formGroupPersonaJuridicaDemandante?.value[
            'primerApellidoRepLegal'
            ]
            : undefined,
          segundoApellido: this.formGroupPersonaJuridicaDemandante?.value[
            'segundoApellidoRepLegal'
          ]
            ? this.formGroupPersonaJuridicaDemandante?.value[
            'segundoApellidoRepLegal'
            ]
            : undefined,
          idTipoIdentificacion: +this.formGroupPersonaJuridicaDemandante?.value[
            'typeOfDocument'
          ]
            ? +this.formGroupPersonaJuridicaDemandante?.value['typeOfDocument']
            : undefined,
          identificacion: this.formGroupPersonaJuridicaDemandante?.value[
            'numeroDocumentoRepLegal'
          ]
            ? this.formGroupPersonaJuridicaDemandante?.value[
            'numeroDocumentoRepLegal'
            ]
            : undefined,
          correoElectronico: this.formGroupPersonaJuridicaDemandante?.value[
            'emailRepLegal'
          ]
            ? this.formGroupPersonaJuridicaDemandante?.value['emailRepLegal']
            : undefined,
          direccionPersona: [
            {
              direccionNotificacion: this.formGroupPersonaJuridicaDemandante
                ?.value['direccionNotificacion']
                ? this.formGroupPersonaJuridicaDemandante?.value[
                'direccionNotificacion'
                ]
                : undefined,
            },
          ],
          municipio: {
            id: this.formGroupPersonaJuridicaDemandante?.value[
              'municipalityRepLegal'
            ]
              ? this.formGroupPersonaJuridicaDemandante?.value[
              'municipalityRepLegal'
              ]
              : undefined,
            idPais: this.formGroupPersonaJuridicaDemandante?.value[
              'countryRepLegal'
            ],
            idDepartamento: this.formGroupPersonaJuridicaDemandante?.value[
              'departamentRepLegal'
            ]
          },
          otroDepartamento: this.formGroupPersonaJuridicaDemandante?.value[
            'otroDepartamentoRepLegal'
          ]
            ? this.formGroupPersonaJuridicaDemandante?.value[
            'otroDepartamentoRepLegal'
            ]
            : undefined,
          otroMunicipio: this.formGroupPersonaJuridicaDemandante?.value[
            'otroMunicipioRepLegal'
          ]
            ? this.formGroupPersonaJuridicaDemandante?.value[
            'otroMunicipioRepLegal'
            ]
            : undefined,
        };

        const item = this.listaTipoSociedad.find(
          item =>
            item.Id ===
            this.formGroupPersonaJuridicaDemandante?.value['tipoSociedad']
        );

        const tipoSociedad: ListaValorRequestDto = {
          valor: item?.Valor,
          estado: item?.Estado,
          nombreLista: item?.Nombre_Lista,
          codigo: item?.Codigo,
          otroValor: item?.Otro_valor,
          idExterno: item?.Id_Externo,
          id: item?.Id,
        };

        demandante = {
          id: this.idDemandante ? this.idDemandante : null,
          idTipoPersona: 2,
          razonSocial: this.formGroupPersonaJuridicaDemandante?.value[
            'razonSocial'
          ]
            ? this.formGroupPersonaJuridicaDemandante?.value['razonSocial']
            : undefined,
          idTipoIdentificacion: this.formGroupPersonaJuridicaDemandante?.value[
            'idTipoIdentificacion'
          ]
            ? this.formGroupPersonaJuridicaDemandante?.value['idTipoIdentificacion']
            : undefined,
          identificacion: this.formGroupPersonaJuridicaDemandante?.value[
            'numeroDocumentoNit'
          ]
            ? this.formGroupPersonaJuridicaDemandante?.value[
            'numeroDocumentoNit'
            ]
            : undefined,
          correoElectronico: this.formGroupPersonaJuridicaDemandante?.value[
            'email'
          ]
            ? this.formGroupPersonaJuridicaDemandante?.value['email']
            : undefined,
          municipio: {
            id: this.formGroupPersonaJuridicaDemandante?.value['municipality']
              ? this.formGroupPersonaJuridicaDemandante?.value['municipality']
              : undefined,
            idPais: this.formGroupPersonaJuridicaDemandante?.value['country'],
            idDepartamento: this.formGroupPersonaJuridicaDemandante?.value['departament']
          },
          otroDepartamento: this.formGroupPersonaJuridicaDemandante?.value[
            'otroDepartamento'
          ]
            ? this.formGroupPersonaJuridicaDemandante?.value['otroDepartamento']
            : undefined,
          otroMunicipio: this.formGroupPersonaJuridicaDemandante?.value[
            'otroMunicipio'
          ]
            ? this.formGroupPersonaJuridicaDemandante?.value['otroMunicipio']
            : undefined,
          direccionPersona: [
            {
              direccionNotificacion: this.formGroupPersonaJuridicaDemandante
                ?.value['address']
                ? this.formGroupPersonaJuridicaDemandante?.value['address']
                : undefined,
            },
          ],
          datosRepresentanteLegal: representanteLegal,
          tipoSociedad: tipoSociedad,
        };
      }
      // Datos de la solicitud
      const item = this.listaTipoEspecieIca.find(
        item =>
          item.Id === this.formGroupInformacionTramite?.value['tipoDeEspecie']
      );
      const listaValor: ListaValorRequestDto = {
        valor: item?.Valor,
        estado: item?.Estado,
        nombreLista: item?.Nombre_Lista,
        codigo: item?.Codigo,
        otroValor: item?.Otro_valor,
        idExterno: item?.Id_Externo,
        id: item?.Id,
      };
      request.tipoEspecie = listaValor;
      request.nombreEspecie = this.formGroupInformacionTramite?.value[
        'nombreEspecie'
      ]
        ? this.formGroupInformacionTramite.value['nombreEspecie']
        : undefined;
      request.variedadVegetal = this.formGroupInformacionTramite.value[
        'denominacionVariedadVegetal'
      ]
        ? this.formGroupInformacionTramite.value['denominacionVariedadVegetal']
        : undefined;
      request.municipio = {
        id: this.formGroupInformacionTramite.value['municipality']
          ? this.formGroupInformacionTramite.value['municipality']
          : undefined,
      };
      request.otroDepartamento = this.formGroupInformacionTramite.value[
        'otroDepartamento'
      ]
        ? this.formGroupInformacionTramite.value['otroDepartamento']
        : undefined;
      request.otroMunicipio = this.formGroupInformacionTramite.value[
        'otroMunicipio'
      ]
        ? this.formGroupInformacionTramite.value['otroMunicipio']
        : undefined;
      request.apoderado = apoderado;
      request.tieneApoderado = true;
      request.demandante = [demandante];
      request.demandado = [demandado];
      request.enviar = false;
      request.id = this.idTramiteObtentorVariedadVegetal ?? null;
      request.enviarCorreoDemandado = this.enviarCorreoDemandado ?? false;
      request.idioma = this.idiomaActual;
      const response = await firstValueFrom(
        this.tramiteIcaService.crearTramiteVariedadVegetal(request)
      );
      this.idTramite = response.data.Id;
      if (this.idTramite) {
        this.idTramiteObtentorVariedadVegetal = this.idTramite;
        this.enviarDocumentos = true;
      }
      const mensajePersonalizado = this.alertaText['ica-alertas']['tramite-enviado-mensaje']
        .replace('{{entidad}}', this.entidad)
        .replace('{{proceso}}', this.proceso);
      await this.alertaModalService.exito(
        this.alertaText['solicitud-pendiente-finalizar'],
        mensajePersonalizado
      );
      if (!response.success) {
        return { success: false };
      } else {
        return { success: true };
      }
    } catch (error) {
      return { success: false, message: 'Error al guardar' };
    }
  }

  archivosGuardados(guardado: boolean) {
    this.enviarDocumentos = false;
  }

  // Se valida que el primer nombre y el primer apellido del representante legal estén diligenciados (En caso de que el demandante sea una persona jurídica)
  // Se valida que el primer nombre y el primer apellido del apoderado estén diligenciados
  validarCamposRepresentante(): boolean {
    if (
      this.formGroupApoderadoTramite?.value['primerNombre'] &&
      this.formGroupApoderadoTramite?.value['primerApellido']
    ) {
      if (this.tipoPersonaDemandante === 2) {
        if (
          this.formGroupPersonaJuridicaDemandante?.value[
          'primeroNombreRepLegal'
          ] &&
          this.formGroupPersonaJuridicaDemandante?.value[
          'primerApellidoRepLegal'
          ]
        ) {
          return true;
        } else {
          return false;
        }
      } else if (this.tipoPersonaDemandante === 1) {
        if (
          this.formGroupPersonaNaturalDemandante?.value['primerNombre'] &&
          this.formGroupPersonaNaturalDemandante?.value['primerApellido']
        ) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  }

  validarPaisDeptoMuni(form: FormGroup, sufix: string) {
    const idPais = this.paises.find(
      item => item.Codigo == Constants.CODIGO_COLOMBIA
    )?.Id;
    if (form?.controls['country' + sufix].value == idPais) {
      form?.controls['departament' + sufix].addValidators(Validators.required);
      form?.controls['municipality' + sufix].addValidators(Validators.required);
      form?.controls['otroDepartamento' + sufix].removeValidators(
        Validators.required
      );
      form?.controls['otroDepartamento' + sufix].updateValueAndValidity();
      form?.controls['otroMunicipio' + sufix].removeValidators(
        Validators.required
      );
      form?.controls['otroMunicipio' + sufix].updateValueAndValidity();
    } else {
      let clearInputs: boolean = false;
      if (form?.controls['country' + sufix].value) {
        if (sufix == 'RepLegal') {
          this.auxIdCountryRl.push(form?.controls['country' + sufix].value);
          if (this.auxIdCountryRl.length > 1) {
            clearInputs =
              form?.controls['country' + sufix].value !=
              this.auxIdCountryRl[this.auxIdCountryRl.length - 2];
          }
        } else {
          this.auxIdCountry.push(form?.controls['country' + sufix].value);
          if (this.auxIdCountry.length > 1) {
            clearInputs =
              form?.controls['country' + sufix].value !=
              this.auxIdCountry[this.auxIdCountry.length - 2];
          }
        }

      }
      if (clearInputs) {
        form?.controls['otroDepartamento' + sufix].setValue('');
        form?.controls['otroMunicipio' + sufix].setValue('');
        this.auxIdCountry = [];
      }
      form?.controls['departament' + sufix].removeValidators(
        Validators.required
      );
      form?.controls['municipality' + sufix].removeValidators(
        Validators.required
      );
      form?.controls['otroDepartamento' + sufix].addValidators(
        Validators.required
      );
      form?.controls['otroDepartamento' + sufix].markAsDirty();
      form?.controls['otroDepartamento' + sufix].markAllAsTouched();
      form?.controls['otroMunicipio' + sufix].addValidators(
        Validators.required
      );
      form?.controls['otroMunicipio' + sufix].markAsDirty();
      form?.controls['otroMunicipio' + sufix].markAllAsTouched();
    }
  }

  //Usado para validar si la persona ya fue agregada como demandante, demando, o apoderado.
  validarPersona(formulario: string) {
    const tipoIdentDemandante: number =
      this.formGroupPersonaNaturalDemandante?.get('typeOfDocument')?.value;
    const identificacionDemandante: number =
      +this.formGroupPersonaNaturalDemandante?.get('numeroDocumento')?.value;

    const tipoIdentApoderado: number =
      this.formGroupApoderadoTramite?.get('typeOfDocument')?.value;
    const identificacionApoderado: number =
      +this.formGroupApoderadoTramite?.get('numeroDocumento')?.value;

    const tipoIdentDemandado: number =
      this.formGroupPersonaNaturalDemandada?.get('typeOfDocument')?.value;
    const identificacionDemandado: number =
      +this.formGroupPersonaNaturalDemandada?.get('numeroDocumento')?.value;

    // Verificar si hay alguna coincidencia en los valores de tipoIdentificacion y numeroIdentificacion
    if (formulario == 'Demandante') {
      if (tipoIdentDemandante !== undefined &&
        identificacionDemandante !== undefined) {
        if (
          (tipoIdentDemandante === tipoIdentApoderado &&
            identificacionDemandante === identificacionApoderado) ||
          (tipoIdentDemandante === tipoIdentDemandado &&
            identificacionDemandante === identificacionDemandado)
        ) {
          this.limpiarDocumentoDuplicado(formulario);
          this.alertaModalService.error(
            this.alertaText['error'],
            this.alertaText['identificacion-ya-agregada']
          );
        }
      }

    } else if (formulario == 'Apoderado') {
      if (
        tipoIdentApoderado !== undefined &&
        identificacionApoderado !== undefined
      ) {
        if (
          (tipoIdentDemandante === tipoIdentApoderado &&
            identificacionDemandante === identificacionApoderado) ||
          (tipoIdentApoderado === tipoIdentDemandado &&
            identificacionApoderado === identificacionDemandado)
        ) {
          this.limpiarDocumentoDuplicado(formulario);
          this.alertaModalService.error(
            this.alertaText['error'],
            this.alertaText['identificacion-ya-agregada']
          );
        }
      }
    } else {
      if (tipoIdentDemandado !== undefined &&
        identificacionDemandado !== undefined) {
        if (
          (tipoIdentDemandado === tipoIdentApoderado &&
            identificacionDemandado === identificacionApoderado) ||
          (tipoIdentDemandante === tipoIdentDemandado &&
            identificacionDemandante === identificacionDemandado)
        ) {
          this.limpiarDocumentoDuplicado(formulario);
          this.alertaModalService.error(
            this.alertaText['error'],
            this.alertaText['identificacion-ya-agregada']
          );
        }
      }
    }
  }

  limpiarDocumentoDuplicado(form: string) {
    switch (form) {
      case 'Apoderado': {
        this.formGroupApoderadoTramite?.get('numeroDocumento')?.setValue('');
        break;
      }
      case 'Demandante': {
        this.formGroupPersonaNaturalDemandante
          ?.get('numeroDocumento')
          ?.setValue('');
        break;
      }
      case 'Demandado': {
        this.formGroupPersonaNaturalDemandada
          ?.get('numeroDocumento')
          ?.setValue('');
        break;
      }
    }
  }

  get correoDemandado(): string {
    return this.demandadoAux?.email ?? '';
  }

  get nombreDemandado(): string {
    const d = this.demandadoAux;
    return `${d.primerNombre ?? ''} ${d.segundoNombre ?? ''} ${d.primerApellido ?? ''} ${d.segundoApellido ?? ''}`.trim();
  }

  rechazarEnvio() {
    this.seleccionAceptoRechazoEnvio = true;
    this.enviarCorreoDemandado = false;
    this.alertaModalService.exito(
      this.comunText['accion-cancelada'],
      this.comunText['rechazo-envio']
    );
  }

  aceptarEnvio() {
    this.seleccionAceptoRechazoEnvio = true;
    this.enviarCorreoDemandado = true;
    this.alertaModalService.exito(
      this.comunText['envio-confirmado'],
      this.comunText['acepta-copia']
    );
  }

  archivosCargados(event: ArchivoItemDto[]) {
    let archivosCargados = event;
    const totalBytes = archivosCargados.reduce(
      (total, archivo) => total + archivo.files.reduce((sum, file) => sum + file.size, 0),
      0
    );
    this.pesoTotalArchivosMB = (totalBytes / (1024 * 1024)).toFixed(2);
  }

  get pesoArchivos(): string {
    return this.pesoTotalArchivosMB;
  }

  setValidadorPais(form: FormGroup, control?: string, controlRp?: string) {
    if (control) {
      if (form.get(control)?.value == 1) {
        form?.controls['departament'].addValidators(Validators.required);
        form?.controls['municipality'].addValidators(Validators.required);
        form?.controls['otroDepartamento'].removeValidators(
          Validators.required
        );
        form?.controls['otroDepartamento'].updateValueAndValidity();
        form?.controls['otroMunicipio'].removeValidators(
          Validators.required
        );
        form?.controls['otroMunicipio'].updateValueAndValidity();
      } else {
        form?.controls['departament'].removeValidators(
          Validators.required
        );
        form?.controls['municipality'].removeValidators(
          Validators.required
        );
        form?.controls['otroDepartamento'].addValidators(
          Validators.required
        );
        form?.controls['otroMunicipio'].addValidators(
          Validators.required
        );
      }
    }
    if (controlRp) {
      if (form.get(controlRp)?.value == 1) {
        form?.controls['departamentRepLegal'].addValidators(Validators.required);
        form?.controls['municipalityRepLegal'].addValidators(Validators.required);
        form?.controls['otroDepartamentoRepLegal'].removeValidators(
          Validators.required
        );
        form?.controls['otroDepartamentoRepLegal'].updateValueAndValidity();
        form?.controls['otroMunicipioRepLegal'].removeValidators(
          Validators.required
        );
        form?.controls['otroMunicipioRepLegal'].updateValueAndValidity();
      } else {
        form?.controls['departamentRepLegal'].removeValidators(
          Validators.required
        );
        form?.controls['municipalityRepLegal'].removeValidators(
          Validators.required
        );
        form?.controls['otroDepartamentoRepLegal'].addValidators(
          Validators.required
        );
        form?.controls['otroMunicipioRepLegal'].addValidators(
          Validators.required
        );
      }
    }

  }
  private validarIdentificacionesActores(): void {
    const idDemandante =
      this.tipoPersonaDemandante === Constants.TIPO_PERSONA.NATURAL
        ? this.formGroupPersonaNaturalDemandante?.get('numeroDocumento')?.value
        : this.formGroupPersonaJuridicaDemandante?.get('numeroDocumento')?.value;

    const idApoderado = this.formGroupApoderadoTramite
      ?.get('numeroDocumento')
      ?.value;

    const idDemandado =
      this.tipoPersonaDemandanda === Constants.TIPO_PERSONA.NATURAL
        ? this.formGroupPersonaNaturalDemandada?.get('numeroDocumento')?.value
        : this.formGroupPersonaJuridicaDemandada?.get('numeroDocumento')?.value;
    const actores = [
      { nombre: Constants.ACTORES.DEMANDANTE, id: idDemandante },
      { nombre: Constants.ACTORES.APODERADO, id: idApoderado },
      { nombre: Constants.ACTORES.DEMANDADO, id: idDemandado },
    ].filter(a => a.id && a.id !== '');
    const duplicados = actores.filter(
      (a, i, arr) => arr.findIndex(b => b.id === a.id) !== i
    );

    if (duplicados.length > 0) {
      this.solicitudTramiteValida = false;
    }
  }

  markFormsAsTouched() {

    // Marcar todos los <app-form>
    if (this.personaComponentes && this.personaComponentes.length > 0) {
      this.personaComponentes.forEach((comp: FormComponent) => {
        comp.marcarTodoComoTocado();
      });
    }
  }

}
